"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

/**
 * icon content should be streamlined through https://jakearchibald.github.io/svgomg/
 * - open svg file in a text editor. copy it, paste it in the markup paste input
 * - copy the resulting markup (just the content, without the svg tag)
 * - create file in ./content with the same name as the icon
 */
var content = {
  addon: function addon(fill) {
    return _react["default"].createElement("path", {
      d: "M29.333 16.889A2.667 2.667 0 0132 19.556v9.777A2.667 2.667 0 0129.333 32h-9.777a2.667 2.667 0 01-2.667-2.667v-9.777a2.667 2.667 0 012.667-2.667h9.777zm-16.889 0a2.667 2.667 0 012.667 2.667v9.777A2.667 2.667 0 0112.444 32H6.222A6.222 6.222 0 010 25.778v-6.222a2.667 2.667 0 012.667-2.667h9.777zm12 1.778c-.736 0-1.333.597-1.333 1.333v3.11L20 23.112a1.333 1.333 0 100 2.667h3.11l.001 3.11a1.333 1.333 0 102.667 0v-3.11h3.11a1.333 1.333 0 000-2.667h-3.11V20c0-.736-.597-1.333-1.334-1.333zm-12 .889H2.667v6.222a3.556 3.556 0 003.555 3.555h6.222v-9.777zM25.778 0A6.222 6.222 0 0132 6.222v6.222a2.667 2.667 0 01-2.667 2.667h-9.777a2.667 2.667 0 01-2.667-2.667V2.667A2.667 2.667 0 0119.556 0h6.222zM12.444 0a2.667 2.667 0 012.667 2.667v9.777a2.667 2.667 0 01-2.667 2.667H2.667A2.667 2.667 0 010 12.444V6.222A6.222 6.222 0 016.222 0h6.222zm13.334 2.667h-6.222v9.777h9.777V6.222a3.556 3.556 0 00-3.555-3.555zm-13.334 0H6.222a3.556 3.556 0 00-3.555 3.555v6.222h9.777V2.667z",
      fill: fill,
      fillRule: "evenodd"
    });
  },
  alert: function alert(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm2-19V8h-4v10h4v-5zm0 7h-4v3.998h4V20z",
      fill: fill
    });
  },
  android: function android(fill) {
    return _react["default"].createElement("path", {
      d: "M8.4 23.992c0 .801.54 1.335 1.35 1.335h1.35v4.672c0 1.068.945 2.002 2.025 2.002s2.025-.934 2.025-2.002v-4.672h2.7v4.672c0 1.068.945 2.002 2.025 2.002s2.025-.934 2.025-2.002v-4.672h1.35c.81 0 1.35-.534 1.35-1.335V10.645H8.4v13.347zM5.025 10.644c-1.08 0-2.025.934-2.025 2.002v9.343c0 1.068.945 2.002 2.025 2.002s2.025-.934 2.025-2.002v-9.343c0-1.068-.945-2.002-2.025-2.002zm22.95 0c-1.08 0-2.025.934-2.025 2.002v9.343c0 1.068.945 2.002 2.025 2.002S30 23.057 30 21.989v-9.343c0-1.068-.945-2.002-2.025-2.002zm-6.75-7.741l1.755-1.735c.27-.267.27-.667 0-.934s-.675-.267-.945 0L20.01 2.236c-.945-.667-2.16-.934-3.51-.934s-2.565.267-3.645.801L10.965.101c-.27-.133-.81-.133-1.08 0-.135.267-.135.801 0 1.068l1.755 1.735C9.75 4.372 8.4 6.641 8.4 9.311h16.2c0-2.669-1.35-5.072-3.375-6.407zM13.8 6.64h-1.35V5.305h1.35V6.64zm6.75 0H19.2V5.305h1.35V6.64z",
      fill: fill
    });
  },
  angleDoubleDown: function angleDoubleDown(fill) {
    return _react["default"].createElement("path", {
      d: "M16 17L27 6l-3-3-8 8-8-8-3 3 11 11zm0 12l11-11-3-3-8 8-8-8-3 3 11 11z",
      fill: fill
    });
  },
  angleDoubleLeft: function angleDoubleLeft(fill) {
    return _react["default"].createElement("path", {
      d: "M3 16l11 11 3-3-8-8 8-8-3-3L3 16zm12 0l11 11 3-3-8-8 8-8-3-3-11 11z",
      fill: fill
    });
  },
  angleDoubleRight: function angleDoubleRight(fill) {
    return _react["default"].createElement("path", {
      d: "M29 16L18 27l-3-3 8-8-8-8 3-3 11 11zm-12 0L6 27l-3-3 8-8-8-8 3-3 11 11z",
      fill: fill
    });
  },
  angleDoubleUp: function angleDoubleUp(fill) {
    return _react["default"].createElement("path", {
      d: "M16 15l11 11-3 3-8-8-8 8-3-3 11-11zm0-12l11 11-3 3-8-8-8 8-3-3L16 3z",
      fill: fill
    });
  },
  angleDown: function angleDown(fill) {
    return _react["default"].createElement("path", {
      d: "M27 12l-3-3-8 8-8-8-3 3 11 11 11-11z",
      fill: fill
    });
  },
  angleLeft: function angleLeft(fill) {
    return _react["default"].createElement("path", {
      d: "M9 16l11.002 11 3-3L15 16l8.002-8-3-3L9 16z",
      fill: fill
    });
  },
  angleRight: function angleRight(fill) {
    return _react["default"].createElement("path", {
      d: "M23.002 16L11.998 27 9 24l7.998-8L9 8l2.998-3 11.004 11z",
      fill: fill
    });
  },
  angleUp: function angleUp(fill) {
    return _react["default"].createElement("path", {
      d: "M16 9L5 20l3 3 8-8 8 8 3-3L16 9z",
      fill: fill
    });
  },
  app: function app(fill) {
    return _react["default"].createElement("path", {
      d: "M28 32H4c-2.208 0-4-1.792-4-4V4c0-2.208 1.792-4 4-4h24c2.208 0 4 1.792 4 4v24c0 2.208-1.792 4-4 4zm-3.042-19.104c-.108-.302-.376-.496-.702-.496h-5.292L16.69 6.7c-.118-.288-.378-.466-.69-.466s-.572.176-.692.468l-2.274 5.7H7.742c-.324 0-.592.192-.698.496s-.018.626.242.824l4.464 3.532-2.002 5.376c-.162.438-.034.902.336 1.184.37.284.852.296 1.232.034L16 20.562l4.684 3.284c.378.264.864.25 1.232-.034.372-.282.498-.746.336-1.184l-2.002-5.376 4.464-3.532c.26-.196.348-.518.244-.824z",
      fill: fill
    });
  },
  apple: function apple(fill) {
    return _react["default"].createElement("path", {
      d: "M14.963 7.303s-.475-2.092 1.39-4.538C18.45.014 21.364.001 21.364.001s.433 2.586-1.649 5.078c-2.224 2.66-4.752 2.225-4.752 2.225zm8.751 9.531c0-4.262 3.451-6.018 3.451-6.018s-1.764-3.177-6.25-3.177c-2.606 0-4.607 1.476-5.686 1.476-1.256 0-3.132-1.387-5.549-1.387-3.718 0-7.681 3.314-7.681 9.631 0 6.421 4.683 14.408 8.389 14.408 1.294 0 3.28-1.297 5.282-1.297 1.964 0 3.414 1.251 5.278 1.251 4.059 0 7.064-8.42 7.064-8.42s-4.299-1.657-4.299-6.465z",
      fill: fill
    });
  },
  apps: function apps(fill) {
    return _react["default"].createElement("path", {
      d: "M6 28v.75C6 30.544 7.456 32 9.25 32h19.5c1.794 0 3.25-1.456 3.25-3.25V9.25C32 7.456 30.544 6 28.75 6H28v17.994C28 26.212 26.206 28 23.994 28H6zm13.88-17.804h-4.41l-1.896-4.804C13.476 5.15 13.26 5 13 5s-.476.148-.576.394l-1.896 4.804h-4.41c-.27 0-.494.162-.582.418s-.014.526.202.694l3.72 2.976-1.668 4.53c-.134.37-.028.76.28.998.308.24.71.25 1.026.028L13 17.072l3.902 2.768c.314.222.72.21 1.026-.028.31-.238.414-.628.28-.998l-1.666-4.53 3.72-2.976c.216-.166.29-.436.204-.694-.092-.256-.314-.418-.586-.418zM22.75 26H3.25C1.456 26 0 24.544 0 22.75V3.25C0 1.456 1.456 0 3.25 0h19.5C24.544 0 26 1.456 26 3.25v19.5c0 1.794-1.456 3.25-3.25 3.25z",
      fill: fill
    });
  },
  appdirect: function appdirect(fill) {
    return _react["default"].createElement("path", {
      d: "M2 24.6l8.8-3.799L14.2 9.4 10 2.8zM10.4 0l1.2 2 9 14.401 6.6-2.801L17.4 0zM32 13.4l-32 14L6.8 32l21.6-9.199z",
      fill: fill
    });
  },
  bank: function bank(fill) {
    return _react["default"].createElement("path", {
      d: "M2.233 27.944v-1.256c0-.411.333-.744.744-.744h26.047c.411 0 .744.333.744.744v1.256h1.488c.411 0 .744.333.744.744V30.2c0 .411-.333.744-.744.744H.744c-.411 0-.744-.333-.744-.744v-1.512c0-.411.333-.744.744-.744h1.488zM4 13.688c0-.411.333-.744.744-.744h1.512c.411 0 .744.333.744.744V23.2c0 .411-.333.744-.744.744H4.744c-.411 0-.744-.333-.744-.744v-9.512zm21 .019c0-.411.333-.744.744-.744h1.512c.411 0 .744.333.744.744v9.512c0 .411-.333.744-.744.744h-1.512c-.411 0-.744-.333-.744-.744v-9.512zm-7 0c0-.411.333-.744.744-.744h1.512c.411 0 .744.333.744.744v9.512c0 .411-.333.744-.744.744h-1.512c-.411 0-.744-.333-.744-.744v-9.512zm-7 0c0-.411.333-.744.744-.744h1.512c.411 0 .744.333.744.744v9.512c0 .411-.333.744-.744.744h-1.512c-.411 0-.744-.333-.744-.744v-9.512zm4.726-11.655c.176-.07.372-.07.547 0l15.256 6.034c.284.112.47.387.47.692v1.281c0 .411-.333.744-.744.744H.743c-.411 0-.744-.333-.744-.744V8.778c0-.305.187-.58.47-.692l15.256-6.034z",
      fill: fill
    });
  },
  banner: function banner(fill) {
    return _react["default"].createElement("path", {
      d: "M4 6v8h24V6H4zM2 2h28c1.105 0 2 .796 2 1.778v12.444c0 .982-.895 1.778-2 1.778H2c-1.105 0-2-.796-2-1.778V3.778C0 2.796.895 2 2 2zm2 28H0v-6c0-1.105.895-2 2-2h28c1.105 0 2 .895 2 2v6h-4v-4H4v4z",
      fill: fill
    });
  },
  bell: function bell(fill) {
    return _react["default"].createElement("path", {
      d: "M24 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM8 20c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2 2 .895 2 2zm20 0c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2 2 .895 2 2zM8 10h16v8H8v-8zm-2 8h20v4H6v-4zm10 12c2.208 0 4-1.792 4-4h-8c0 2.208 1.792 4 4 4zM8 16c0 1.106-.894 2-2 2h6v-2H8zm16 0c0 1.106.894 2 2 2h-6v-2h4zM4 20h24v4H4v-4zM16 0c-1.106 0-2 .894-2 2v8h4V2c0-1.106-.894-2-2-2z",
      fill: fill
    });
  },
  blockquote: function blockquote(fill) {
    return _react["default"].createElement("path", {
      d: "M6.2 15.554H2V5h11.2v7.951C13.2 21.699 9.467 26.382 2 27v-3.958c2.8-.761 4.2-2.888 4.2-6.383v-1.105zm16.8 0h-4.2V5H30v7.951C30 21.699 26.267 26.382 18.8 27v-3.958c2.8-.761 4.2-2.888 4.2-6.383v-1.105z",
      fill: fill
    });
  },
  briefcase: function briefcase(fill) {
    return _react["default"].createElement("path", {
      d: "M12 6V4h8v2h2V2c0-1.2-.8-2-2-2h-8c-1.2 0-2 .8-2 2v4h2zM4 6c-2.2 0-4 1.8-4 4v18c0 2.2 1.8 4 4 4h2V6H4zm4 0h16v26H8V6zm20 0h-2v26h2c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4z",
      fill: fill
    });
  },
  book: function book(fill) {
    return _react["default"].createElement("path", {
      d: "M26 0H8C5.792 0 4 1.792 4 4v26c0 1.106.894 2 2 2h16c1.106 0 2-.894 2-2V6c0-1.106-.894-2-2-2H6c0-1.106.894-2 2-2h18v28h2V2c0-1.106-.894-2-2-2z",
      fill: fill
    });
  },
  bookmark: function bookmark(fill) {
    return _react["default"].createElement("path", {
      d: "M22.6 25.2L16 22l-6.6 3.2c-.6.4-1.4 0-1.4-.8V8c0-1.2.8-2 2-2h12c1.2 0 2 .8 2 2v16.4c0 .8-.8 1.2-1.4.8z",
      fill: fill
    });
  },
  bolt: function bolt(fill) {
    return _react["default"].createElement("path", {
      d: "M16.014.281l-11.92 18.73c-.254.4.034.922.508.922h10.906l-1.606 11.246c-.092.64.754.952 1.1.406l11.92-18.73c.254-.4-.034-.922-.508-.922H15.508L17.114.687c.092-.64-.752-.952-1.1-.406z",
      fill: fill
    });
  },
  box: function box(fill) {
    return _react["default"].createElement("path", {
      d: "M0 2v28h32V2H0zm26 22H6V8h20v16z",
      fill: fill
    });
  },
  button: function button(fill) {
    return _react["default"].createElement("path", {
      d: "M0 8h32v16H0V8zm4 4v8h24v-8H4zm4 2h16v4H8v-4z",
      fill: fill
    });
  },
  calendar: function calendar(fill) {
    return _react["default"].createElement("path", {
      d: "M18 16h-4v4h4v-4zm8-12V2c0-1.104-.896-2-2-2h-2c-1.104 0-2 .896-2 2v2h-8V2c0-1.104-.896-2-2-2H8C6.896 0 6 .896 6 2v2H2v28h28V4h-4zm0 24H6V14h20v14zm-8-6h-4v4h4v-4zm6-6h-4v4h4v-4zm-12 0H8v4h4v-4zm0 6H8v4h4v-4zm12 0h-4v4h4v-4z",
      fill: fill
    });
  },
  carousel: function carousel(fill) {
    return _react["default"].createElement("path", {
      d: "M8.6 4h14.8C24.836 4 26 5.164 26 6.6v18.8c0 1.436-1.164 2.6-2.6 2.6H8.6C7.164 28 6 26.836 6 25.4V6.6C6 5.164 7.164 4 8.6 4zM10 8v16h12V8H10zm22-2v20h-1.4c-1.436 0-2.6-1.164-2.6-2.6V8.6C28 7.164 29.164 6 30.6 6H32zM0 5.66h1.4c1.436 0 2.6 1.164 2.6 2.6v14.8c0 1.436-1.164 2.6-2.6 2.6H0v-20z",
      fill: fill
    });
  },
  cart: function cart(fill) {
    return _react["default"].createElement("path", {
      d: "M14 29c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm10 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm6-27h-4c-.8 0-1.6.6-2 1.4L22.8 8H3.2C1.8 8 .8 9.6 1.4 10.8l4 8c.4.8 1 1.2 1.8 1.2H22l2 1.8v.2H8c-1.2 0-2 .8-2 2s.8 2 2 2h18c1.2 0 2-.8 2-2v-3c0-.6-.2-1-.6-1.4l-3-3L27.6 6H30c1.2 0 2-.8 2-2s-.8-2-2-2z",
      fill: fill
    });
  },
  categories: function categories(fill) {
    return _react["default"].createElement("path", {
      d: "M10 10V4H4v6h6zm2.25 4H1.75C.784 14 0 13.216 0 12.25V1.75C0 .784.784 0 1.75 0h10.5C13.216 0 14 .784 14 1.75v10.5c0 .966-.784 1.75-1.75 1.75zM10 28v-6H4v6h6zm2.25 4H1.75C.784 32 0 31.216 0 30.25v-10.5C0 18.784.784 18 1.75 18h10.5c.966 0 1.75.784 1.75 1.75v10.5c0 .966-.784 1.75-1.75 1.75zM18 2h14v4H18V2zm0 18h14v4H18v-4zm0-12h14v4H18V8zm0 18h14v4H18v-4z",
      fill: fill
    });
  },
  check: function check(fill) {
    return _react["default"].createElement("path", {
      d: "M25 5.8l-11.998 12L7 11.8l-5.198 5.202L13 28.202l17.2-17.2z",
      fill: fill
    });
  },
  circleEmpty: function circleEmpty(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-29C8.832 3 3 8.832 3 16s5.832 13 13 13 13-5.832 13-13S23.168 3 16 3z",
      fill: fill
    });
  },
  circlePartiallySolid: function circlePartiallySolid(fill) {
    return _react["default"].createElement("g", null, _react["default"].createElement("path", {
      d: "M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-29C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13S23.2 3 16 3z",
      fill: fill
    }), _react["default"].createElement("path", {
      d: "M20.3 16c0 2.375-1.925 4.3-4.3 4.3s-4.3-1.925-4.3-4.3 1.925-4.3 4.3-4.3 4.3 1.925 4.3 4.3z",
      fill: fill
    }));
  },
  circleSolid: function circleSolid(fill) {
    return _react["default"].createElement("path", {
      d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z",
      fill: fill
    });
  },
  clip: function clip(fill) {
    return _react["default"].createElement("path", {
      d: "M11.179 30.308c1.423 1.169 3.287 1.777 5.124 1.687 1.688-.066 3.342-.725 4.618-1.828 1.434-1.218 2.383-2.984 2.605-4.851.076-.583.055-1.172.061-1.758.006-2.557.021-5.112.023-7.668-.018-1.755-1.135-3.431-2.74-4.129-1.385-.64-3.088-.526-4.375.292-1.157.714-1.972 1.96-2.147 3.31-.058.385-.041.774-.048 1.162-.008 1.934-.016 3.867-.025 5.8-.019.453.379.863.832.859.573.003 1.147.003 1.721.001.441.003.83-.382.83-.823.01-2.107.021-4.215.033-6.323-.012-.399.172-.801.496-1.042.447-.362 1.152-.35 1.586.033.301.241.465.626.457 1.009-.01 2.832-.018 5.663-.033 8.493-.035 1.722-1.244 3.336-2.883 3.863-1.034.347-2.203.282-3.184-.2-1.426-.673-2.402-2.196-2.395-3.775.001-5.624-.005-11.249.002-16.871.003-1.749 1.221-3.403 2.883-3.939 1.034-.349 2.201-.274 3.184.2 1.336.631 2.279 2.004 2.381 3.478.027.563.029 1.126.043 1.688-.002.229-.002.458-.004.689-.016.451.381.859.834.856.572.003 1.146.003 1.719.001.441.005.832-.381.832-.821 0-.406-.006-.755-.012-1.098v-.084c-.009-.328-.007-.66-.017-.989.002-.051 0-.102.002-.153l-.006-.01c-.014-.304-.035-.604-.08-.906-.283-1.835-1.256-3.562-2.705-4.731C19.361.548 17.484-.077 15.629.012c-1.687.063-3.34.722-4.618 1.823-1.471 1.251-2.436 3.08-2.625 5.001-.056.51-.037 1.021-.04 1.534 0 5.049.001 10.1 0 15.15.002.687-.022 1.379.093 2.058.284 1.845 1.285 3.564 2.74 4.73z",
      fill: fill
    });
  },
  clock: function clock(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm0-28C9.374 4 4 9.374 4 16c0 6.624 5.376 12 12 12s12-5.376 12-12c0-6.626-5.376-12-12-12zm-2 14V8h4v8h3.998v4H14v-2z",
      fill: fill
    });
  },
  clockSolid: function clockSolid(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.998 20H14V8h4v8h3.998v4z",
      fill: fill
    });
  },
  close: function close(fill) {
    return _react["default"].createElement("path", {
      d: "M24 8.5L21.5 6 15 12.5 8.5 6 6 8.5l6.5 6.5L6 21.5 8.5 24l6.5-6.5 6.5 6.5 2.5-2.5-6.5-6.5z",
      fill: fill
    });
  },
  cloud: function cloud(fill) {
    return _react["default"].createElement("path", {
      d: "M27.866 14.326c.066-.436.134-.872.134-1.326 0-4.97-4.03-9-9-9-3.196 0-5.984 1.676-7.582 4.186C10.962 8.076 10.49 8 10 8c-3.314 0-6 2.686-6 6 0 .122.028.236.036.356C1.692 15.172 0 17.378 0 20c0 3.314 2.686 6 6 6h20c3.314 0 6-2.686 6-6 0-2.658-1.74-4.886-4.134-5.674z",
      fill: fill
    });
  },
  code: function code(fill) {
    return _react["default"].createElement("path", {
      d: "M10.2 21l-3.198 3.198L0 17l7.002-7.198L10.2 13l-4 4 4 4zm14.798 3.198L21.8 21l3.998-4-3.998-4 3.198-3.198L32 17l-7.002 7.198zM16 28h-4l4-22h4l-4 22z",
      fill: fill
    });
  },
  cog: function cog(fill) {
    return _react["default"].createElement("path", {
      d: "M32.026 14v4l-4.998 1-1.102 2.656 2.828 4.246-2.828 2.828-4.244-2.828L19.026 27l-1 5h-4l-1-5-2.684-1.074L6.1 28.754l-2.828-2.828L6.1 21.684 5.024 19 .026 18v-4l5-1 1.1-2.658L3.296 6.1l2.828-2.828L10.37 6.1 13.026 5l1-5h4l1 5 2.632 1.128 4.24-2.83 2.828 2.83-2.828 4.24L27.028 13l4.998 1zm-16.024-3.974c-3.314 0-6.002 2.688-6.002 5.998 0 3.316 2.688 6.004 6.002 6.004 3.31 0 5.998-2.688 5.998-6.004 0-3.31-2.688-5.998-5.998-5.998z",
      fill: fill
    });
  },
  cogs: function cogs(fill) {
    return _react["default"].createElement("path", {
      d: "M8.488 25.964c-1.368 0-2.478-1.11-2.478-2.478s1.11-2.478 2.478-2.478 2.478 1.11 2.478 2.478-1.108 2.478-2.478 2.478zm6.94-7.436l-1.982-1.982-3.578 1.788-2.202-3.338-2.708.726-.24 3.992-3.992.24L0 22.662l3.338 2.204-1.788 3.576 1.982 1.982 3.576-1.788 2.204 3.338 2.708-.726.24-3.992 3.992-.24.726-2.708-3.338-2.204 1.788-3.576zm5.948-4.46c-1.916 0-3.47-1.554-3.47-3.47s1.554-3.47 3.47-3.47 3.47 1.554 3.47 3.47-1.554 3.47-3.47 3.47zm7.72-4.382L32 7.776l-1.022-2.528-3.418.644-1.372-1.398.704-3.402-2.51-1.066-1.958 2.87-1.952.008L18.566 0l-2.53 1.02.646 3.414-1.408 1.352-3.404-.704-1.064 2.508 2.87 1.958-.016 1.962-2.906 1.91 1.022 2.528 3.416-.646 1.372 1.398-.704 3.402 2.51 1.066 1.958-2.87 1.97.04 1.908 2.904 2.528-1.022-.644-3.414 1.388-1.398 3.404.704 1.066-2.51-2.87-1.958.018-1.958z",
      fill: fill
    });
  },
  comment: function comment(fill) {
    return _react["default"].createElement("path", {
      d: "M16.818 25.93c-4.652 5.042-12.876 2.988-12.876 2.988 3.916-.948 4.706-3.092 4.656-4.77C4.65 22.03 2 18.292 2 14 2 7.372 8.266 2 16 2c7.732 0 14 5.372 14 12 0 6.388-5.84 11.556-13.182 11.93z",
      fill: fill
    });
  },
  company: function company(fill) {
    return _react["default"].createElement("path", {
      d: "M28 0H4C2.8 0 2 .8 2 2v30h10v-2h8v2h10V2c0-1.2-.8-2-2-2zM18 6h6v4h-6V6zm0 8h6v4h-6v-4zm-4 12H8v-4h6v4zm0-8H8v-4h6v4zm0-8H8V6h6v4zm4 16v-4h6v4h-6z",
      fill: fill
    });
  },
  compare: function compare(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0c1.105 0 2 .895 2 2v28c0 1.105-.895 2-2 2s-2-.895-2-2V2c0-1.105.895-2 2-2zM2.35 12.239l10.929 6.831c.462.288.721.755.721 1.302s-.259 1.014-.721 1.299L2.35 28.502c-.486.306-1.056.322-1.558.042C.288 28.264 0 27.776 0 27.2V13.541c0-.576.29-1.064.792-1.344.502-.277 1.069-.261 1.558.042zm27.3-8c.488-.304 1.056-.32 1.558-.042.502.28.792.768.792 1.344V19.2c0 .576-.288 1.064-.792 1.344-.502.28-1.072.264-1.558-.042l-10.929-6.831c-.462-.285-.721-.753-.721-1.299s.259-1.014.721-1.302L29.65 4.239z",
      fill: fill
    });
  },
  components: function components(fill) {
    return _react["default"].createElement("path", {
      d: "M4.5 2.408h6c1.933 0 3.5 1.567 3.5 3.5v6c0 1.933-1.567 3.5-3.5 3.5h-6c-1.933 0-3.5-1.567-3.5-3.5v-6c0-1.933 1.567-3.5 3.5-3.5zm0 2.999c-.276 0-.5.224-.5.5v6c0 .276.224.5.5.5h6c.276 0 .5-.224.5-.5v-6c0-.276-.224-.5-.5-.5h-6zM23.694 1.47l5.196 3c1.674.966 2.248 3.107 1.281 4.781l-3 5.196c-.966 1.674-3.107 2.248-4.781 1.281l-5.196-3c-1.674-.966-2.248-3.107-1.281-4.781l3-5.196c.966-1.674 3.107-2.248 4.781-1.281zm-1.5 2.598c-.239-.138-.545-.056-.683.183l-3 5.196c-.138.239-.056.545.183.683l5.196 3c.239.138.545.056.683-.183l3-5.196c.138-.239.056-.545-.183-.683l-5.196-3zM4.5 17.407h6c1.933 0 3.5 1.567 3.5 3.5v6c0 1.933-1.567 3.5-3.5 3.5h-6c-1.933 0-3.5-1.567-3.5-3.5v-6c0-1.933 1.567-3.5 3.5-3.5zm0 3c-.276 0-.5.224-.5.5v6c0 .276.224.5.5.5h6c.276 0 .5-.224.5-.5v-6c0-.276-.224-.5-.5-.5h-6zm15-3h6c1.933 0 3.5 1.567 3.5 3.5v6c0 1.933-1.567 3.5-3.5 3.5h-6c-1.933 0-3.5-1.567-3.5-3.5v-6c0-1.933 1.567-3.5 3.5-3.5zm0 3c-.276 0-.5.224-.5.5v6c0 .276.224.5.5.5h6c.276 0 .5-.224.5-.5v-6c0-.276-.224-.5-.5-.5h-6z",
      fill: fill
    });
  },
  confluence: function confluence(fill) {
    return _react["default"].createElement("path", {
      d: "M22.654 20.702c-.402-.792-.878-1.594-1.436-2.408-.398-.584-.826-1.152-1.274-1.71-.182-.226-.106-.508.034-.648.138-.14.276-.282.414-.422 1.912-1.95 3.888-3.964 5.402-6.142 1.612-2.316 2.504-4.512 2.73-6.774.022-.226-.08-.468-.264-.608-.12-.092-.266-.14-.414-.14-.082 0-.164.016-.242.044-1.47.562-2.962.988-4.324 1.306-.278.064-.502.272-.596.52-.992 2.718-3.526 5.306-6.186 8.018-.106.102-.256.234-.5.234-.242 0-.392-.13-.5-.234-2.658-2.712-5.192-5.29-6.186-8.01-.094-.248-.318-.454-.596-.518-1.362-.318-2.856-.78-4.324-1.342-.078-.03-.162-.046-.244-.046-.146 0-.292.048-.412.14-.188.142-.286.374-.264.608.226 2.26 1.118 4.484 2.73 6.8 1.516 2.178 3.492 4.192 5.402 6.142 3.52 3.59 6.846 6.982 7.138 10.914.026.354.322.63.678.63h4.136c.186 0 .364-.076.492-.212s.196-.316.186-.502c-.036-.74-.144-1.482-.318-2.226l.002-.002c-.006-.022-.008-.044-.008-.068 0-.152.116-.276.27-.276.012 0 .026.002.038.004 3.376.494 5.512 1.284 5.516 2.154v.002c0 .82-1.92 2.056-5.04 2.962l-.002.002c-.278.08-.48.33-.48.628 0 .36.298.654.666.654.052 0 .1-.006.148-.016 4.194-.97 6.976-2.6 6.976-4.442.008-2.184-3.75-4.136-9.348-5.016zM11.562 18.57c-.084-.088-.254-.208-.482-.208-.308 0-.492.2-.562.306-.452.688-.846 1.366-1.186 2.036-5.59.882-9.342 2.832-9.342 5.016 0 1.842 2.76 3.47 6.964 4.44h.006c.05.012.1.02.154.02.368 0 .666-.294.666-.654 0-.296-.202-.544-.478-.624l-.002-.004c-3.12-.906-5.04-2.144-5.04-2.962v-.002c.004-.868 2.134-1.656 5.502-2.152.012-.002.024-.004.036-.004.154 0 .274.126.274.278 0 .024-.004.046-.01.068l.002.002c-.174.742-.278 1.48-.316 2.216-.01.186.058.37.188.504.128.134.308.212.494.212h4.136c.356 0 .654-.278.68-.632.09-1.21.468-2.424 1.154-3.698.238-.442.054-.856-.084-1.032-.68-.888-1.514-1.832-2.754-3.126zm3.962-10.22c.164.158.348.188.476.188s.314-.03.478-.188c1.458-1.418 2.242-3.072 2.414-3.532.026-.068.05-.144.05-.252 0-.368-.306-.63-.626-.63-.264 0-1.016.078-2.312.078h-.008c-1.296 0-2.048-.078-2.312-.078-.32 0-.626.262-.626.63 0 .108.026.184.05.252.172.46.956 2.114 2.416 3.532z",
      fill: fill
    });
  },
  copy: function copy(fill) {
    return _react["default"].createElement("path", {
      d: "M24 3H5v23c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3h16c1.7 0 3 1.3 3 3zM11 6h16c1.7 0 3 1.3 3 3v20c0 1.7-1.3 3-3 3H11c-1.7 0-3-1.3-3-3V9c0-1.7 1.3-3 3-3zm0 3v20h16V9H11z",
      fill: fill
    });
  },
  creditCard: function creditCard(fill) {
    return _react["default"].createElement("path", {
      d: "M30 6H2C.896 6 0 6.896 0 8v18c0 1.106.896 2 2 2h28c1.106 0 2-.894 2-2V8c0-1.104-.894-2-2-2zm-2 18h-6v-6h6v6zm0-10H4v-4h24v4z",
      fill: fill
    });
  },
  creditCardStripe: function creditCardStripe(fill) {
    return _react["default"].createElement("path", {
      d: "M29.23 7H2.77C1.244 7 0 8.195 0 9.664v13.432C0 24.563 1.244 26 2.77 26h26.46c1.525 0 2.77-1.438 2.77-2.904V9.664C32 8.195 30.756 7 29.23 7zM30 23.096c0 .238-.521.904-.77.904H2.77c-.249 0-.77-.666-.77-.904V17h28v6.096zM2 13V9.664c0-.24.52-.664.77-.664h26.46c.248 0 .77.424.77.664V13H2z",
      fill: fill
    });
  },
  delivery: function delivery(fill) {
    return _react["default"].createElement("path", {
      d: "M19.148 22.006c-1.18-1.405-2.849-2.315-4.652-2.52l-.793-2.958c-.186-.694.226-1.406.919-1.592l14.342-3.842c.694-.186 1.407.226 1.593.919l1.398 5.216c.186.694-.226 1.406-.919 1.592l-11.888 3.185zm1.201 2.014l9.97-2.671c.694-.186 1.407.226 1.593.919l.017.064c.186.694-.226 1.406-.919 1.592l-10.134 2.715c-.01-.593-.093-1.196-.253-1.796-.076-.283-.167-.558-.273-.824zm-7.978-4.445c-.147.029-.295.064-.442.103-.744.199-1.427.513-2.037.919L4.972 2.66H1.33C.595 2.66 0 2.065 0 1.33S.596 0 1.33 0h4.621c.279 0 .538.086.752.233.277.172.493.446.584.786l5.084 18.557zm-.206-13.811l7.536-2.019c.694-.186 1.407.226 1.593.919l1.398 5.216c.186.694-.226 1.406-.919 1.592l-7.536 2.019c-.694.186-1.407-.226-1.593-.919l-1.398-5.216c-.186-.694.226-1.406.919-1.592zm3.018 26.058c-2.775.743-5.642-.961-6.405-3.806s.869-5.754 3.643-6.497c2.775-.743 5.642.961 6.405 3.806s-.869 5.754-3.643 6.497zm-.673-2.512c1.373-.368 2.199-1.841 1.804-3.313s-1.847-2.335-3.22-1.967c-1.373.368-2.199 1.841-1.804 3.313s1.847 2.335 3.22 1.967z",
      fill: fill
    });
  },
  desktop: function desktop(fill) {
    return _react["default"].createElement("path", {
      d: "M24 29.816V30c0 1.104-.896 2-2 2H10c-1.104 0-2-.896-2-2v-.184c1.162-.412 2-1.512 2-2.816v-1h12v1c0 1.304.838 2.404 2 2.816zM32 2v20c0 1.104-.896 2-2 2H2c-1.104 0-2-.896-2-2V2C0 .896.896 0 2 0h28c1.104 0 2 .896 2 2zM2 18h28V4H2v14z",
      fill: fill
    });
  },
  dislike: function dislike(fill) {
    return _react["default"].createElement("path", {
      d: "M14 32l8-16-10 4-1.675 7.26C9.593 30.43 11.588 32.482 14 32zm4-12l1.368-1.824C19.912 17.451 22 16 22 16L19 2H6.996C4.789 2 2.707 3.759 2.341 5.95L.495 17.028C.221 18.67 1.353 20 3.012 20h14.987zm14-2V2h-9l3 16h6z",
      fill: fill
    });
  },
  divider: function divider(fill) {
    return _react["default"].createElement("path", {
      d: "M0 18h32v-4H0v4zM16 1l-6 9h12l-6-9zm0 30l6-9H10l6 9z",
      fill: fill
    });
  },
  download: function download(fill) {
    return _react["default"].createElement("path", {
      d: "M22 12h-4V2h-6v10H8l7 9 7-9zM6 32H0V16h6v10h18V16h6v16H6z",
      fill: fill
    });
  },
  dropdown: function dropdown(fill) {
    return _react["default"].createElement("path", {
      d: "M16 3l-6 9h12l-6-9zm0 26l6-9H10l6 9z",
      fill: fill
    });
  },
  ellipsis: function ellipsis(fill) {
    return _react["default"].createElement("path", {
      d: "M12 16c0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4-4 1.791-4 4zM0 16c0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4-4 1.791-4 4zm24 0c0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4-4 1.791-4 4z",
      fill: fill
    });
  },
  error: function error(fill) {
    return _react["default"].createElement("path", {
      d: "M29.958 29.97H1.93c-1.728 0-2.45-1.224-1.618-2.732L14.404 1.13c.834-1.508 2.182-1.508 3.014 0l14.156 26.108c.832 1.508.11 2.732-1.616 2.732zM18.002 10.04H14v10h4v-10h.002zm0 12H14v4h4v-4h.002z",
      fill: fill
    });
  },
  exCircle: function exCircle(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm5.168-24.032L16 13.134l-5.166-5.166-2.87 2.868 5.166 5.168-5.164 5.164 2.866 2.868L16 18.868l5.168 5.168 2.866-2.868-5.166-5.164 5.168-5.168-2.868-2.868z",
      fill: fill
    });
  },
  eye: function eye(fill) {
    return _react["default"].createElement("path", {
      d: "M17 11c-.1.4-.2.7-.2 1.2 0 1.7 1.4 3 3 3 .4 0 .8-.1 1.1-.2.1.3.1.6.1.9 0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5c.3 0 .7.1 1 .1zm-1-5c6.6 0 12.5 4 16 10-3.5 6-9.4 10-16 10S3.5 22 0 16C3.5 10 9.4 6 16 6zm0 18c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z",
      fill: fill
    });
  },
  eyeClosed: function eyeClosed(fill) {
    return _react["default"].createElement("path", {
      d: "M26.3 4.8L3.7 27.6l-2.1-2.2L5 21.9c-1.9-1.6-3.6-3.6-5-6 3.5-6 9.4-10 16-10 1.5 0 2.9.2 4.3.6l3.9-3.9 2.1 2.2zm-.2 4.5c2.3 1.7 4.3 4 5.9 6.7-3.5 6.1-9.4 10.1-16 10.1-1.9 0-3.8-.3-5.6-1l1.9-1.9c1.1.6 2.3.9 3.7.9 4.4 0 8-3.6 8-8.1 0-1.3-.3-2.6-.9-3.7l3-3zm-5.2 5.3c.1.4.2.9.2 1.4 0 2.8-2.2 5-5 5-.5 0-1-.1-1.4-.2l6.2-6.2zM8.4 18.5l2.7-2.7c.1-2.6 2.2-4.7 4.8-4.8l2.6-2.6c-.8-.3-1.6-.4-2.5-.4-4.4 0-8 3.6-8 8.1 0 .8.1 1.6.4 2.4z",
      fill: fill
    });
  },
  facebook: function facebook(fill) {
    return _react["default"].createElement("path", {
      d: "M30.2 0H1.8C.8 0 0 .8 0 1.8v28.4c0 1 .8 1.8 1.8 1.8h15.4V19.6H13v-4.8h4.2v-3.6c0-4.2 2.6-6.4 6.2-6.4 1.8 0 3.2.2 3.8.2v4.4h-2.6c-2 0-2.4 1-2.4 2.4v3H27l-.6 4.8H22V32h8.2c1 0 1.8-.8 1.8-1.8V1.8c0-1-.8-1.8-1.8-1.8z",
      fill: fill
    });
  },
  file: function file(fill) {
    return _react["default"].createElement("path", {
      d: "M18 4H8v24h16V10h-4c-1.105 0-2-.895-2-2V4zm2.343-4L28 7.657V30c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2h14.343zM10 14h12v2H10v-2zm0 6v-2h12v2H10zm0 4v-2h10v2H10z",
      fill: fill
    });
  },
  filter: function filter(fill) {
    return _react["default"].createElement("path", {
      d: "M4 7h24v4H4V7zM9 15h14v4H9v-4zM13 23h6v4h-6v-4z",
      fill: fill
    });
  },
  fingerprint: function fingerprint(fill) {
    return _react["default"].createElement("path", {
      d: "M6 32V14.2c0-5.6 4.4-10 10-10s10 4.4 10 10V32h4V14.2c0-7.8-6.2-14-14-14S2 6.4 2 14.2V32h4zm4-6c-1.2 0-2-.8-2-2v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v4c0 1.2-.8 2-2 2s-2-.8-2-2v-4c0-2.2-1.8-4-4-4s-4 1.8-4 4v8c0 1.2-.8 2-2 2zm6-4c-1.2 0-2-.8-2-2v-2c0-1.2.8-2 2-2s2 .8 2 2v2c0 1.2-.8 2-2 2zm8 4c0-1.2-.8-2-2-2s-2 .8-2 2v6h4v-6zm-6 0c0-1.2-.8-2-2-2s-2 .8-2 2v6h4v-6zm-6 4c0-1.2-.8-2-2-2s-2 .8-2 2v2h4v-2z",
      fill: fill
    });
  },
  fitHeight: function fitHeight(fill) {
    return _react["default"].createElement("path", {
      d: "M16.971 27H30v3H2v-3h13.172L9 20.828 11.828 18l4.243 4.243L20.314 18l2.828 2.828L16.97 27zm-1.9-22H2V2h28v3H17.071l6.071 6.071-2.828 2.828-4.243-4.243-4.243 4.243L9 11.071 15.071 5z",
      fill: fill
    });
  },
  folderClosed: function folderClosed(fill) {
    return _react["default"].createElement("path", {
      d: "M26.998 8h-9.992c-.002 0-.002-.002-.004-.002-.556 0-1-.45-1-1 0-.002-.002-.002-.002-.004-.004-1.656-1.346-2.992-3.002-2.992H5.002C3.344 4.002 2 5.34 2 7v17.998C2 26.656 3.344 28 5.002 28h21.996C28.656 28 30 26.656 30 24.998v-14C30 9.344 28.656 8 26.998 8z",
      fill: fill
    });
  },
  folderNew: function folderNew(fill) {
    return _react["default"].createElement("path", {
      d: "M26.998 7.998c1.658 0 3.002 1.344 3.002 2.998v14c0 1.658-1.344 3.002-3.002 3.002H5.002C3.344 27.998 2 26.654 2 24.996V6.998C2 5.338 3.344 4 5.002 4h7.996C14.654 4 15.996 5.336 16 6.992c0 .002.002.002.002.004 0 .55.444 1 1 1 .002 0 .002.002.004.002h9.992zM14 23.998h4v-4h4v-4h-4v-4h-4v4h-4v4h4v4z",
      fill: fill
    });
  },
  folderOpen: function folderOpen(fill) {
    return _react["default"].createElement("path", {
      d: "M0 16h32l-3.316 9.946C28.27 27.196 27.154 28 25.838 28H6.162c-1.316 0-2.426-.804-2.844-2.052L0 16zm27-8h-9.998c-.556 0-1-.45-1-1 0-1.658-1.344-2.998-3.002-2.998H5c-1.654 0-2.998 1.34-2.998 2.998v7h28.002v-3.002C30.002 9.342 28.66 8 27 8z",
      fill: fill
    });
  },
  footer: function footer(fill) {
    return _react["default"].createElement("path", {
      d: "M0 16h32v16H0V16zm4 4v8h24v-8H4zM0 0h32v4H0V0zm0 8h32v4H0V8z",
      fill: fill
    });
  },
  frown: function frown(fill) {
    return _react["default"].createElement("path", {
      d: "M8 14c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm16 0c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm5 10.6c-2.2-5-7.2-8.6-13-8.6S5.2 19.6 3 24.6c-.6 1.6.6 3.4 2.4 3.4 1 0 1.8-.6 2.2-1.6C9 23.2 12.2 21 15.8 21s6.8 2.2 8.2 5.4c.4 1 1.2 1.6 2.2 1.6 2.2 0 3.4-1.8 2.8-3.4z",
      fill: fill
    });
  },
  frownBig: function frownBig(fill) {
    return _react["default"].createElement("path", {
      d: "M24 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zM8 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm20 13.4c-.6-3.8-2.8-7.4-6.4-9.6-3.4-2.4-7.6-2.4-11.2-.2S4.6 21.4 4 25.4c-.4 2.2 2 3.6 3.6 2 1-1 2.2-2 3.6-2.6 3.2-1.6 7.2-1.6 10.4.2 1.2.6 2.2 1.4 3 2.4 1.4 1.4 3.8.2 3.4-2z",
      fill: fill
    });
  },
  fullscreen: function fullscreen(fill) {
    return _react["default"].createElement("path", {
      d: "M6 20H2v10h10v-4H6v-6zm-4-8h4V6h6V2H2v10zm24 14h-6v4h10V20h-4v6zM20 2v4h6v6h4V2H20z",
      fill: fill
    });
  },
  graphBar: function graphBar(fill) {
    return _react["default"].createElement("path", {
      d: "M0 32h8V20H0v12zm12 0h8V10h-8v22zm12 0h8V0h-8v32z",
      fill: fill
    });
  },
  graphLine: function graphLine(fill) {
    return _react["default"].createElement("path", {
      d: "M32 6c0-3.314-2.686-6-6-6s-6 2.686-6 6c0 2.09 1.068 3.93 2.688 5.004l-1.256 5.022c-.718.068-1.398.26-2.018.558l-3.998-3.998c.374-.782.584-1.66.584-2.586 0-3.314-2.686-6-6-6s-6 2.686-6 6c0 1.924.906 3.636 2.314 4.734L4.496 20.19C1.91 20.858 0 23.206 0 26c0 3.314 2.686 6 6 6s6-2.686 6-6c0-2.39-1.398-4.454-3.42-5.418L10.108 16c.886-.016 1.726-.224 2.478-.584l3.998 3.998C16.21 20.196 16 21.074 16 22c0 3.314 2.686 6 6 6s6-2.686 6-6c0-2.09-1.068-3.93-2.688-5.004l1.256-5.024C29.616 11.688 32 9.122 32 6zM9 26c0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3 3 1.344 3 3zm1-13c-1.656 0-3-1.344-3-3s1.344-3 3-3 3 1.344 3 3-1.344 3-3 3zm12 12c-1.656 0-3-1.344-3-3s1.344-3 3-3 3 1.344 3 3-1.344 3-3 3zm1-19c0-1.656 1.344-3 3-3s3 1.344 3 3-1.344 3-3 3-3-1.344-3-3z",
      fill: fill
    });
  },
  graphPie: function graphPie(fill) {
    return _react["default"].createElement("path", {
      d: "M16 16H0C0 7.163 7.163 0 16 0v16zm0 16c8.837 0 16-7.163 16-16C32 7.841 25.893 1.108 18 .124V6.2c4.564.927 8 4.962 8 9.8 0 5.523-4.477 10-10 10-4.838 0-8.873-3.436-9.8-8H.124C1.108 25.893 7.841 32 16 32z",
      fill: fill
    });
  },
  grid: function grid(fill) {
    return _react["default"].createElement("path", {
      d: "M22 26v-4h4v4h-4zm0-12h4v4h-4v-4zm0-8h4v4h-4V6zm-8 16h4v4h-4v-4zm0-8h4v4h-4v-4zm0-8h4v4h-4V6zM6 22h4v4H6v-4zm0-8h4v4H6v-4zm0-8h4v4H6V6z",
      fill: fill
    });
  },
  hamburger: function hamburger(fill) {
    return _react["default"].createElement("path", {
      d: "M4 7h24v3H4V7zm0 8h24v3H4v-3zm0 8h24v3H4v-3z",
      fill: fill
    });
  },
  header: function header(fill) {
    return _react["default"].createElement("path", {
      d: "M0 0h32v16H0V0zm4 4v8h24V4H4zM0 20h32v4H0v-4zm0 8h32v4H0v-4z",
      fill: fill
    });
  },
  heart: function heart(fill) {
    return _react["default"].createElement("path", {
      d: "M28.669 5.072c-3.11-3.11-8.15-3.11-11.26 0L16.001 6.48l-1.408-1.408c-3.11-3.11-8.15-3.11-11.26 0s-3.11 8.152 0 11.26L16.001 29l12.668-12.668c3.11-3.11 3.11-8.15 0-11.26z",
      fill: fill
    });
  },
  home: function home(fill) {
    return _react["default"].createElement("path", {
      d: "M28 14v18H18V21.998h-4V32H4V14H0L16 0l16 14h-4z",
      fill: fill
    });
  },
  image: function image(fill) {
    return _react["default"].createElement("path", {
      d: "M19 14c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm7 8.5V24H6v-3.9l5.4-5.4c.4-.4 1-.4 1.4 0l6 6 2-2c.4-.4 1-.4 1.4 0l3.8 3.8zM28 6H4v20h24V6zm2-4c1.1 0 2 .9 2 2v24c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h28z",
      fill: fill
    });
  },
  imageViewer: function imageViewer(fill) {
    return _react["default"].createElement("path", {
      d: "M9 32H3c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1zm10 0h-6c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1zm10 0h-6c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1zM4.6 0h22.8C28.836 0 30 1.164 30 2.6v14.8c0 1.436-1.164 2.6-2.6 2.6H4.6C3.164 20 2 18.836 2 17.4V2.6C2 1.164 3.164 0 4.6 0zM6 4v12h20V4H6z",
      fill: fill
    });
  },
  imageWithText: function imageWithText(fill) {
    return _react["default"].createElement("path", {
      d: "M4 9v14h6V9H4zM0 5h14v22H0V5zm18 0h14v4H18V5zm0 6h14v4H18v-4zm0 6h10v4H18v-4z",
      fill: fill
    });
  },
  "import": function _import(fill) {
    return _react["default"].createElement("path", {
      d: "M20 18v-2h4V4c0-2.2-1.8-4-4-4H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h4c1.2 0 2-.8 2-2v-2h8c1.2 0 2-.8 2-2zM3.8 8H10l2-6 2 6h6.2l-5 3.4 1.6 6-4.8-4-4.8 3.8 1.6-5.8-5-3.4zM22 22v-3.8l9.8 6.8-9.8 6.8V28H12v-6z",
      fill: fill
    });
  },
  importApp: function importApp(fill) {
    return _react["default"].createElement("path", {
      d: "M20 18v-2h4V4c0-2.2-1.8-4-4-4H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h4c1.2 0 2-.8 2-2v-2h8c1.2 0 2-.8 2-2zM3.8 8H10l2-6 2 6h6.2l-5 3.4 1.6 6-4.8-4-4.8 3.8 1.6-5.8-5-3.4zM22 22v-3.8l9.8 6.8-9.8 6.8V28H12v-6z",
      fill: fill
    });
  },
  inbox: function inbox(fill) {
    return _react["default"].createElement("path", {
      d: "M27.8 3.4c-.2-.8-1-1.4-2-1.4H6.2c-1 0-1.8.6-2 1.4L0 18v10c0 1.2.8 2 2 2h28c1.2 0 2-.8 2-2V18L27.8 3.4zM25.2 18c-.8 0-1.4.4-1.8 1L21 23c-.2.6-1 1-1.6 1h-6.8c-.8 0-1.4-.4-1.8-1l-2.4-4c-.2-.6-.8-1-1.6-1H4L7.4 7.4c.2-.8 1-1.4 1.8-1.4h13.4c1 0 1.8.6 2 1.4L28 18h-2.8z",
      fill: fill
    });
  },
  info: function info(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm2 25h-4V13h4v12zm0-16h-4V5h4v4z",
      fill: fill
    });
  },
  instagram: function instagram(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0c4.345 0 4.89.018 6.597.096 1.703.078 2.866.348 3.884.744 1.052.409 1.944.956 2.834 1.845s1.437 1.782 1.845 2.834c.395 1.018.666 2.181.744 3.884C31.982 11.11 32 11.654 32 16s-.018 4.89-.096 6.597c-.078 1.703-.348 2.866-.744 3.884-.409 1.052-.956 1.944-1.845 2.834s-1.782 1.437-2.834 1.845c-1.018.395-2.181.666-3.884.744C20.89 31.982 20.346 32 16 32s-4.89-.018-6.597-.096c-1.703-.078-2.866-.348-3.884-.744-1.052-.409-1.944-.956-2.834-1.845S1.248 27.533.84 26.481C.444 25.463.174 24.3.096 22.597.018 20.89 0 20.346 0 16s.018-4.89.096-6.597C.174 7.7.444 6.537.84 5.519c.409-1.052.956-1.944 1.845-2.834S4.467 1.248 5.519.84C6.537.444 7.7.174 9.403.096 11.11.018 11.654 0 16 0zm0 2.883c-4.272 0-4.778.016-6.465.093-1.56.071-2.407.332-2.971.551-.747.29-1.28.637-1.84 1.197s-.907 1.093-1.197 1.84c-.219.564-.48 1.411-.551 2.971-.077 1.687-.093 2.193-.093 6.465s.016 4.778.093 6.465c.071 1.56.332 2.407.551 2.971.29.747.637 1.28 1.197 1.84s1.093.907 1.84 1.197c.564.219 1.411.48 2.971.551 1.687.077 2.193.093 6.465.093s4.778-.016 6.465-.093c1.56-.071 2.407-.332 2.971-.551.747-.29 1.28-.637 1.84-1.197s.907-1.093 1.197-1.84c.219-.564.48-1.411.551-2.971.077-1.687.093-2.193.093-6.465s-.016-4.778-.093-6.465c-.071-1.56-.332-2.407-.551-2.971-.29-.747-.637-1.28-1.197-1.84s-1.093-.907-1.84-1.197c-.564-.219-1.411-.48-2.971-.551-1.687-.077-2.193-.093-6.465-.093zm0 18.45c2.945 0 5.333-2.388 5.333-5.333S18.945 10.667 16 10.667c-2.946 0-5.333 2.388-5.333 5.333s2.388 5.333 5.333 5.333zm0-13.549c4.538 0 8.216 3.679 8.216 8.216S20.538 24.216 16 24.216c-4.538 0-8.216-3.678-8.216-8.216S11.462 7.784 16 7.784zm10.461-.325c0 1.06-.86 1.92-1.92 1.92s-1.92-.86-1.92-1.92.86-1.92 1.92-1.92 1.92.86 1.92 1.92z",
      fill: fill
    });
  },
  invoice: function invoice(fill) {
    return _react["default"].createElement("path", {
      d: "M15.091 22.413v-3.687c-.044-.012-.094-.024-.148-.037-.122-.029-.255-.056-.399-.079-.531-.117-1.056-.255-1.573-.413s-.98-.369-1.39-.632c-.409-.263-.736-.591-.98-.984s-.366-.881-.366-1.467c0-.597.14-1.124.42-1.581s.65-.84 1.11-1.15c.46-.31.991-.55 1.594-.72.559-.157 1.136-.257 1.731-.298v-1.361h1.6v1.371c.577.063 1.122.171 1.634.324.567.17 1.066.404 1.497.703s.783.67 1.056 1.115c.273.445.431.972.474 1.581h-3.059c-.014-.468-.194-.866-.539-1.194-.3-.285-.655-.447-1.064-.484v3.138c.112.023.226.045.342.068.18.035.37.076.571.123 1.063.234 1.881.524 2.456.869s.998.705 1.271 1.08c.273.375.434.749.485 1.124s.075.708.075 1.001c0 .258-.079.582-.237.975s-.442.776-.851 1.15c-.409.375-.959.708-1.648 1.001-.649.276-1.471.448-2.464.515v1.539h-1.6v-1.537c-1.54-.109-2.749-.51-3.627-1.203-.905-.714-1.429-1.762-1.573-3.144h3.038c-.014.667.201 1.194.646 1.581.413.358.918.596 1.516.712zm1.6.005c.201-.027.408-.07.622-.128.28-.076.531-.184.754-.325s.406-.313.549-.518c.144-.205.215-.448.215-.729 0-.457-.176-.799-.528-1.027-.326-.211-.863-.405-1.613-.581v3.309zm-1.6-6.172v-2.832c-.194.009-.383.037-.568.084-.23.059-.438.149-.625.272s-.334.275-.442.457c-.108.181-.162.395-.162.641 0 .386.151.685.452.896.28.196.728.356 1.344.481zM18 4H8v24h16V10h-4c-1.105 0-2-.895-2-2V4zm2.343-4L28 7.657V30c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2h14.343z",
      fill: fill
    });
  },
  jbilling: function jbilling(fill) {
    return _react["default"].createElement("path", {
      d: "M16.458 16.062zM16 32l14-8.842V8.422L16 0zm-2 0L1.368 22.736 14 16z",
      fill: fill
    });
  },
  jira: function jira(fill) {
    return _react["default"].createElement("path", {
      d: "M9.112 6.122c1.16 0 2.096-.94 2.096-2.098 0-1.162-.938-2.098-2.096-2.098s-2.096.938-2.096 2.098c0 1.158.938 2.098 2.096 2.098zm13.774 0c1.156 0 2.096-.94 2.096-2.098 0-1.162-.94-2.098-2.096-2.098-1.16 0-2.096.938-2.096 2.098 0 1.158.938 2.098 2.096 2.098zM16 4.208c1.16 0 2.096-.94 2.096-2.098C18.096.948 17.16.012 16 .012c-1.158 0-2.096.936-2.096 2.098-.002 1.158.936 2.098 2.096 2.098zm4.242 16.628c1.846-1.882 3.756-3.83 5.22-5.932 1.558-2.238 2.42-4.36 2.638-6.544.022-.22-.078-.452-.254-.588-.116-.088-.256-.136-.4-.136-.078 0-.158.014-.234.044-1.42.542-2.862.956-4.178 1.262-.268.062-.486.262-.576.502-.958 2.626-3.406 5.126-5.974 7.746-.104.098-.248.228-.482.228s-.378-.126-.482-.228c-2.568-2.62-5.016-5.11-5.974-7.738-.09-.24-.306-.438-.574-.5-1.316-.306-2.762-.732-4.18-1.274-.076-.03-.156-.044-.234-.044-.142 0-.28.044-.396.134-.182.138-.276.364-.254.58.218 2.184 1.08 4.318 2.638 6.556 1.464 2.104 3.374 4.05 5.218 5.932 3.402 3.47 6.614 6.746 6.896 10.546.026.342.312.608.656.608h3.996c.18 0 .352-.074.476-.204s.19-.306.18-.486c-.126-2.54-1.082-5.084-2.922-7.776-.386-.564-.8-1.114-1.232-1.652-.176-.218-.102-.49.032-.628.128-.136.262-.27.396-.408zm-8.53 2.956c-.094-.098-.234-.2-.466-.2-.298 0-.476.206-.542.308-1.68 2.558-2.548 4.972-2.668 7.398-.008.178.058.356.182.488.124.13.298.204.478.204h3.99c.344 0 .632-.268.658-.61.088-1.17.452-2.342 1.114-3.572.23-.426.052-.826-.082-.998-.66-.856-1.466-1.768-2.664-3.018zm3.826-9.874c.158.154.338.182.46.182H16c.124 0 .302-.028.46-.182 1.41-1.37 2.166-2.968 2.332-3.412.024-.066.048-.14.048-.242 0-.354-.296-.608-.604-.608-.256 0-.982.076-2.234.076h-.008c-1.252 0-1.978-.076-2.232-.076-.31 0-.606.254-.606.608 0 .104.024.178.05.242.166.444.924 2.042 2.332 3.412z",
      fill: fill
    });
  },
  key: function key(fill) {
    return _react["default"].createElement("path", {
      d: "M16 15.718c3.444-.892 6-3.994 6-7.718 0-4.418-3.582-8-8-8S6 3.582 6 8c0 3.724 2.556 6.824 6 7.718V32h8v-4h-4v-2h4v-4h-4v-6.282zM10 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4z",
      fill: fill
    });
  },
  language: function language(fill) {
    return _react["default"].createElement("path", {
      d: "M15.984 0C7.152 0 0 7.168 0 16s7.152 16 15.984 16C24.832 32 32 24.832 32 16S24.832 0 15.984 0zm11.088 9.6h-4.72c-.512-2-1.248-3.92-2.208-5.696 2.944 1.008 5.392 3.056 6.928 5.696zM16 3.264c1.328 1.92 2.368 4.048 3.056 6.336h-6.112c.688-2.288 1.728-4.416 3.056-6.336zM3.616 19.2C3.36 18.176 3.2 17.104 3.2 16s.16-2.176.416-3.2h5.408C8.896 13.856 8.8 14.912 8.8 16s.096 2.144.224 3.2H3.616zm1.312 3.2h4.72c.512 2 1.248 3.92 2.208 5.696-2.944-1.008-5.392-3.04-6.928-5.696zm4.72-12.8h-4.72c1.536-2.656 3.984-4.688 6.928-5.696C10.896 5.68 10.16 7.6 9.648 9.6zM16 28.736c-1.328-1.92-2.368-4.048-3.056-6.336h6.112c-.688 2.288-1.728 4.416-3.056 6.336zm3.744-9.536h-7.488C12.112 18.144 12 17.088 12 16s.112-2.16.256-3.2h7.488c.144 1.04.256 2.112.256 3.2s-.112 2.144-.256 3.2zm.4 8.896c.96-1.776 1.696-3.696 2.208-5.696h4.72c-1.536 2.64-3.984 4.688-6.928 5.696zm2.832-8.896c.128-1.056.224-2.112.224-3.2s-.096-2.144-.224-3.2h5.408c.256 1.024.416 2.096.416 3.2s-.16 2.176-.416 3.2h-5.408z",
      fill: fill
    });
  },
  laptop: function laptop(fill) {
    return _react["default"].createElement("path", {
      d: "M30 24V6c0-1.104-.896-2-2-2H4c-1.104 0-2 .896-2 2v18H0v3c0 .552.448 1 1 1h30c.552 0 1-.448 1-1v-3h-2zM6 8h20v14H6V8zm14 18h-8l-2-2h12l-2 2z",
      fill: fill
    });
  },
  lead: function lead(fill) {
    return _react["default"].createElement("path", {
      d: "M6 32H4V0h24v32h-2.5l-.4-.2-9-4.7-9.7 5zm3.1-21.9c-.3 0-.5.2-.6.4-.1.3 0 .5.2.7l3.7 2.9-1.7 4.4c-.1.4 0 .7.3 1 .3.2.7.2 1 0l3.9-2.7 3.9 2.7c.3.2.7.2 1 0s.4-.6.3-1l-1.7-4.4 3.7-2.9c.2-.2.3-.4.2-.7s-.3-.4-.6-.4h-4.4l-1.9-4.7c-.2-.5-1-.5-1.2 0l-1.9 4.7z",
      fill: fill
    });
  },
  like: function like(fill) {
    return _react["default"].createElement("path", {
      d: "M10 16l8-16c2.412-.482 4.407 1.57 3.675 4.74L20 12h8.987c1.66 0 2.791 1.331 2.517 2.972L29.658 26.05C29.293 28.242 27.21 30 25.003 30H12.999l-3-14zM0 16v16h10L6 16H0z",
      fill: fill
    });
  },
  link: function link(fill) {
    return _react["default"].createElement("path", {
      d: "M19.98 25.682l-.134.164-3.328 3.326v-.004c-1.888 1.89-4.362 2.836-6.84 2.836s-4.956-.946-6.842-2.836c-3.778-3.776-3.778-9.902 0-13.682h-.004L6.16 12.16c1.084-.982 2.736-1 3.838-.04 1.104.96 1.318 2.594.496 3.806l-.23.342-3.324 3.326c-.732.73-1.134 1.704-1.134 2.734s.404 2.004 1.138 2.738c.728.73 1.702 1.13 2.734 1.13 1.034 0 2.004-.4 2.738-1.13l3.322-3.328.216-.172c1.16-.924 2.83-.82 3.866.238 1.042 1.064 1.108 2.736.16 3.878zm9.186-9.162l-3.322 3.324-.192.146c-1.138.876-2.744.784-3.776-.216s-1.172-2.606-.33-3.772l.192-.262 3.322-3.326c.732-.732 1.134-1.704 1.134-2.738 0-1.03-.402-2.002-1.136-2.738-.728-.732-1.702-1.132-2.736-1.132s-2.002.4-2.734 1.134l-3.324 3.326-.292.212c-1.202.878-2.876.7-3.866-.41s-.976-2.794.034-3.888l.018-.022 3.326-3.322C17.372.946 19.846 0 22.322 0c2.478 0 4.958.946 6.844 2.836 3.778 3.778 3.778 9.906 0 13.684z",
      fill: fill
    });
  },
  linkedin: function linkedin(fill) {
    return _react["default"].createElement("path", {
      d: "M29.6 0H2.4C1 0 0 1 0 2.4v27.4C0 31 1 32 2.4 32h27.2c1.4 0 2.4-1 2.4-2.4V2.4C32 1 31 0 29.6 0zM9.4 27H4.8V12h4.8v15zM7.2 10c-1.6 0-2.8-1.4-2.8-2.8 0-1.6 1.2-2.8 2.8-2.8S10 5.6 10 7.2C9.8 8.6 8.6 10 7.2 10zm20 17h-4.8v-7.2c0-1.8 0-4-2.4-4s-2.8 2-2.8 4V27h-4.8V12H17v2c.6-1.2 2.2-2.4 4.4-2.4 4.8 0 5.6 3.2 5.6 7.2V27z",
      fill: fill
    });
  },
  list: function list(fill) {
    return _react["default"].createElement("path", {
      d: "M11.998 26v-4h16.004v4H11.998zm0-12h16.004v4H11.998v-4zm0-8h16.004v4H11.998V6zM4 22h4v4H4v-4zm0-8h4v4H4v-4zm0-8h4v4H4V6z",
      fill: fill
    });
  },
  lock: function lock(fill) {
    return _react["default"].createElement("path", {
      d: "M26 16h-2v-6c0-4.418-3.582-8-8-8s-8 3.582-8 8v6H6c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2V18c0-1.104-.896-2-2-2zm-8 9c0 .552-.448 1-1 1h-2c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h2c.552 0 1 .448 1 1v2zm-6-9v-6c0-2.21 1.79-4 4-4s4 1.79 4 4v6h-8z",
      fill: fill
    });
  },
  mapUnfolded: function mapUnfolded(fill) {
    return _react["default"].createElement("path", {
      d: "M22 0l9.25 7.4c.474.378.75.954.75 1.562v19.506c0 1.554-1.696 2.514-3.03 1.714L22 26V0zm-2 0l-8 8v24l8-6V0zM.97 26.582L10 32V8L3.25 2.6C1.94 1.552 0 2.484 0 4.162v20.706c0 .702.368 1.354.97 1.714z",
      fill: fill
    });
  },
  marketplace: function marketplace(fill) {
    return _react["default"].createElement("path", {
      d: "M28.455 15v11.75c0 .69-.581 1.25-1.297 1.25h-7.006v-5.9c0-.055-.046-.1-.104-.1h-8.096c-.057 0-.104.045-.104.1V28H4.842c-.717 0-1.297-.56-1.297-1.25V15h3.892c.906 0 1.729-.344 2.335-.905.606.56 1.429.905 2.335.905h1.557c.906 0 1.729-.344 2.335-.905.606.56 1.429.905 2.335.905h1.557c.906 0 1.729-.344 2.335-.905.606.56 1.429.905 2.335.905h3.892zM17.142 3h3.944c.057 0 .104.045.104.1v8.65c0 .69-.581 1.25-1.297 1.25h-1.557c-.717 0-1.297-.56-1.297-1.25V3.1c0-.055.046-.1.104-.1zm-6.228 0h3.944c.057 0 .104.045.104.1v8.65c0 .69-.581 1.25-1.297 1.25h-1.557c-.717 0-1.297-.56-1.297-1.25V3.1c0-.055.046-.1.104-.1zM6.022 3H8.63c.057 0 .104.045.104.1v8.65c0 .69-.581 1.25-1.297 1.25H3.298c-.717 0-1.297-.56-1.297-1.25 0-.141.025-.28.073-.413l2.725-7.5C4.981 3.336 5.472 3 6.024 3zm17.347 0h2.609c.551 0 1.042.336 1.225.837l2.725 7.5c.237.652-.12 1.365-.796 1.593-.138.046-.283.07-.429.07h-4.139c-.717 0-1.297-.56-1.297-1.25V3.1c0-.055.046-.1.104-.1z",
      fill: fill
    });
  },
  media: function media(fill) {
    return _react["default"].createElement("path", {
      d: "M27.707 26.969c.737-.147 1.293-.798 1.293-1.579V10.746c0-.885-.721-1.605-1.609-1.605H17.037c-1.404-.005-2.534-1.139-2.534-2.532-.003-.892-.722-1.608-1.611-1.608H4.61c-.891 0-1.609.716-1.609 1.605v18.216l7.522-7.114c.463-.471 1.213-.471 1.675 0l7.108 7.24 2.369-2.413c.463-.471 1.213-.471 1.675 0l4.355 4.436zM12.891 2c2.387 0 4.348 1.809 4.587 4.141h9.913c2.545 0 4.609 2.063 4.609 4.605V25.39c0 2.546-2.064 4.61-4.609 4.61H4.609C2.063 30 0 27.936 0 25.39V6.605C0 4.058 2.063 2 4.609 2h8.282zm5.766 17.24c-1.963 0-3.554-1.621-3.554-3.62S16.694 12 18.657 12c1.963 0 3.554 1.621 3.554 3.62s-1.591 3.62-3.554 3.62z",
      fill: fill
    });
  },
  microsoft: function microsoft(fill) {
    return _react["default"].createElement("path", {
      d: "M0 0v14h14V0H0zm18 0v14h14V0H18zM0 18v14h14V18H0zm18 0v14h14V18H18z",
      fill: fill
    });
  },
  minus: function minus(fill) {
    return _react["default"].createElement("path", {
      d: "M32 19.916L0 20v-8h32z",
      fill: fill
    });
  },
  minusCircle: function minusCircle(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.998 18H8v-4h15.998v4z",
      fill: fill
    });
  },
  mobile: function mobile(fill) {
    return _react["default"].createElement("g", null, _react["default"].createElement("clipPath", {
      id: "a"
    }, _react["default"].createElement("path", {
      d: "M10 5.56h12v16H10zm8 21c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h2c.55 0 1 .45 1 1zm4-25H10c-1.1 0-2 .96-2 2.15V27.4c0 1.19.9 2.15 2 2.15h12c1.1 0 2-.96 2-2.15V3.71c0-1.19-.9-2.15-2-2.15z"
    })), _react["default"].createElement("path", {
      clipPath: "url(#a)",
      d: "M3-3.44h26v38H3z",
      fill: fill
    }));
  },
  module: function module(fill) {
    return _react["default"].createElement("path", {
      d: "M14 24h4v-4h4v-4h-4v-4h-4v4h-4v4h4v4zM0 0v32h32V0H0zm28 28H4V8h24v20z",
      fill: fill
    });
  },
  more: function more(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zM8.052 18.528c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5c0 1.382-1.12 2.5-2.5 2.5zm8 0c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5c0 1.382-1.12 2.5-2.5 2.5zm8 0c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5c0 1.382-1.12 2.5-2.5 2.5z",
      fill: fill
    });
  },
  network: function network(fill) {
    return _react["default"].createElement("path", {
      d: "M26 28.002V22h-4v6.002h-4V18h4v-4H10v4h4v10.002h-4V22H6v6.002H2V18h4v-8h8V6h-4V2h12v4h-4v4h8v8h3.998v10.002H26z",
      fill: fill
    });
  },
  noSync: function noSync(fill) {
    return _react["default"].createElement("g", null, _react["default"].createElement("path", {
      d: "M18.914 9.856c-1.201-.64-2.557-1-3.973-1-3.303 0-6.085 1.739-7.476 4.694l2.26 2.26H1.032V7.117L3.64 9.725C6.074 5.9 10.246 3.64 14.94 3.64c2.682 0 5.229.789 7.392 2.152l-3.418 4.064zm3.749 3.85c.379.759.652 1.583.797 2.451l5.216-.869c-.34-2.152-1.196-4.139-2.431-5.839l-3.581 4.257zM12.65 25.921c.734.209 1.503.32 2.29.32 3.129 0 6.085-1.912 7.476-4.694l-2.26-2.26h8.693v8.693l-2.608-2.608c-2.434 3.651-6.78 6.085-11.3 6.085-2.067 0-4.054-.469-5.847-1.308l3.557-4.228zM8.189 22.918c-.892-1.13-1.518-2.487-1.767-3.979l-5.216.869c.435 2.752 1.714 5.233 3.549 7.191l3.433-4.082z",
      fill: fill
    }), _react["default"].createElement("path", {
      d: "M26.189 4.302L4.1 31.054l-4.101-3.432L22.088.87l4.101 3.432z",
      fill: fill
    }));
  },
  opportunities: function opportunities(fill) {
    return _react["default"].createElement("path", {
      d: "M16.9 6.1L19.8.4c.1-.3.3-.4.6-.4H29c.1 0 .2 0 .3.1.3.1.4.5.3.8L25 9.6c-2.1-2-5-3.3-8.1-3.5zM6.8 9.3L2.6.9c-.1-.3 0-.7.3-.8 0-.1.1-.1.2-.1h8.6c.2 0 .4.1.5.3L15 6c-3.1.2-6 1.4-8.2 3.3zM15.7 32C9.1 32 3.8 26.6 3.8 20S9.1 8 15.7 8s11.9 5.4 11.9 12-5.3 12-11.9 12zm7.9-14.7c-.1-.3-.3-.4-.6-.4h-4.7l-2-5c-.1-.3-.3-.4-.6-.4s-.5.2-.6.4l-2 5H8.4c-.3 0-.5.2-.6.4-.1.3 0 .6.2.7l3.9 3.1-1.8 4.8c-.1.4 0 .8.3 1 .3.3.7.3 1.1 0l4.1-2.9 4.1 2.9c.3.2.8.2 1.1 0s.4-.7.3-1l-1.8-4.8 3.9-3.1c.4-.2.5-.4.4-.7z",
      fill: fill
    });
  },
  pageTabs: function pageTabs(fill) {
    return _react["default"].createElement("path", {
      d: "M28 10c2.209 0 4 1.791 4 4v12c0 2.209-1.791 4-4 4H4c-2.209 0-4-1.791-4-4V6c0-2.209 1.791-4 4-4h20c2.209 0 4 1.791 4 4v4zm-16 0h4V6h-4v4zm8 0h4V6h-4v4zM4 26h24V14H8V6H4v20z",
      fill: fill
    });
  },
  paymentApproved: function paymentApproved(fill) {
    return _react["default"].createElement("path", {
      d: "M29 17.607V9.415C29 8.083 27.873 7 26.49 7H2.51C1.127 7 0 8.083 0 9.415v12.172c0 1.327 1.122 2.407 2.5 2.412.003 0 .006.001.01.001h18.703c.655 2.307 2.773 4 5.287 4 3.032 0 5.5-2.467 5.5-5.5 0-2.133-1.223-3.98-3-4.893zM2 9.415C2 9.197 2.284 9 2.51 9h23.98c.226 0 .51.197.51.415V12H2V9.415zM21.025 22H2.51c-.226 0-.51-.197-.51-.413V16h25v1.025c-.165-.014-.331-.025-.5-.025-2.863 0-5.221 2.2-5.475 5zm8.918-1.031l-4.014 4.496-2.613-2.928.479-.537h-.001l.735-.825.734.825.666.746 2.801-3.139 1.213 1.362z",
      fill: fill
    });
  },
  paymentError: function paymentError(fill) {
    return _react["default"].createElement("path", {
      d: "M29 17.607V9.415C29 8.083 27.873 7 26.49 7H2.51C1.127 7 0 8.083 0 9.415v12.172c0 1.327 1.122 2.407 2.5 2.412.003 0 .006.001.01.001h18.703c.655 2.305 2.774 4 5.287 4 3.032 0 5.5-2.467 5.5-5.499 0-2.133-1.222-3.981-3-4.894zM2 9.415C2 9.197 2.284 9 2.51 9h23.98c.226 0 .51.197.51.415V12H2V9.415zM21.025 22H2.51c-.226 0-.51-.197-.51-.413V16h25v1.025c-.165-.014-.331-.025-.5-.025-2.864 0-5.221 2.201-5.475 5zm8.368 2.581l-.802.801-2.084-2.079-2.084 2.079-.802-.801 2.085-2.079-2.085-2.08.802-.8 2.084 2.08 2.084-2.08.802.8-2.082 2.08 2.082 2.079z",
      fill: fill
    });
  },
  pencil: function pencil(fill) {
    return _react["default"].createElement("path", {
      d: "M27.668 9.668l-5.336-5.336L26.668 0 32 5.332l-4.332 4.336zm-3.002 2.998l-12 12-5.332-5.334L19.332 7.334l5.334 5.332zM8 29.334L0 32l2.666-8.002 1.666-1.666 5.336 5.336L8 29.334z",
      fill: fill
    });
  },
  phone: function phone(fill) {
    return _react["default"].createElement("path", {
      d: "M7.41 23.326C12.276 28.192 18 31 22 32c4-1 7-5 8-6s-2.042-4.042-3-5c0 0-3-4-5-3 0 0-3.572 2.776-4 3-1.1.574-2.466.036-3.342-.84l-4.084-4.086c-2.192-2.19-.546-5.042-.276-5.536.392-.718 2.32-2.32 2.32-2.32.638-.638.638-1.674 0-2.314L7.41.698C6.452-.26 4.958-.218 4 .74c0 0-1.746 1.494-2.206 2.102C1.036 3.85-.054 5 0 8s2.288 10.204 7.41 15.326z",
      fill: fill
    });
  },
  pin: function pin(fill) {
    return _react["default"].createElement("path", {
      d: "M15 0C8.926 0 4 4.926 4 11s11 21 11 21 11-14.926 11-21S21.074 0 15 0zm0 16c-2.762 0-5-2.238-5-5s2.238-5 5-5 5 2.238 5 5-2.238 5-5 5z",
      fill: fill
    });
  },
  plus: function plus(fill) {
    return _react["default"].createElement("path", {
      d: "M0 20v-8h12V0h8v12h12v8H20v12h-8V20H0z",
      fill: fill
    });
  },
  plusCircle: function plusCircle(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.998 18H18v5.998h-4V18H8v-4h6V8h4v6h5.998v4z",
      fill: fill
    });
  },
  priceQuote: function priceQuote(fill) {
    return _react["default"].createElement("path", {
      d: "M6 0h20c1.105 0 2 .895 2 2v28c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2zm2 4v4h16V4H8zm6 20v4h10v-4H14zM8 12v4h4v-4H8zm0 6v4h4v-4H8zm6-6v4h4v-4h-4zm0 6v4h4v-4h-4zm6-6v4h4v-4h-4zm0 6v4h4v-4h-4zM8 24v4h4v-4H8z",
      fill: fill
    });
  },
  productTile: function productTile(fill) {
    return _react["default"].createElement("path", {
      d: "M6 26h20V6H6v20zm20.5 4h-21C3.568 30 2 28.432 2 26.5v-21C2 3.568 3.568 2 5.5 2h21C28.432 2 30 3.568 30 5.5v21c0 1.932-1.568 3.5-3.5 3.5zm-2.204-16.415c.096.283.015.582-.226.763l-4.134 3.271 1.854 4.979c.15.406.033.835-.311 1.097-.341.263-.791.276-1.141.032L16 20.686l-4.338 3.043c-.352.243-.798.232-1.141-.032-.343-.261-.461-.691-.311-1.097l1.854-4.979L7.93 14.35c-.241-.183-.322-.482-.224-.763s.346-.459.646-.459h4.901l2.106-5.279c.111-.27.352-.433.641-.433s.53.165.639.432l2.106 5.279h4.901c.302 0 .55.18.65.459z",
      fill: fill
    });
  },
  productGroups: function productGroups(fill) {
    return _react["default"].createElement("path", {
      d: "M4 10v18h22v.75c0 1.794-1.456 3.25-3.25 3.25H3.25C1.456 32 0 30.544 0 28.75V9.25C0 7.456 1.456 6 3.25 6H4v4zm24 12V4H10v18h18zm.75 4H9.25C7.456 26 6 24.544 6 22.75V3.25C6 1.456 7.456 0 9.25 0h19.5C30.544 0 32 1.456 32 3.25v19.5c0 1.794-1.456 3.25-3.25 3.25zm-2.5-15.328c.084.248.013.508-.198.667l-3.613 2.859 1.62 4.351c.131.355.029.73-.272.958-.298.23-.691.241-.997.028l-3.791-2.658-3.791 2.66c-.308.212-.698.202-.997-.028-.299-.228-.403-.604-.272-.958l1.62-4.351-3.613-2.859c-.21-.16-.282-.421-.196-.667s.303-.401.565-.401h4.283l1.841-4.614c.097-.236.308-.379.56-.379s.463.144.558.377l1.841 4.614h4.283c.264 0 .481.157.568.401z",
      fill: fill
    });
  },
  purchases: function purchases(fill) {
    return _react["default"].createElement("path", {
      d: "M28 4h4c0 4.3-1.6 8.1-4 10.1zM4 4v10.1C1.6 12.1 0 8.3 0 4zm10 19.5c-4.6-.9-8-4.9-8-9.6V0h20v13.9c0 4.8-3.4 8.7-8 9.6V26h2v2h4v4H8v-4h4v-2h2zm8-15.1c-.1-.2-.3-.3-.5-.3H18l-1.5-3.8c-.1-.2-.3-.3-.5-.3s-.4.1-.5.3L14 8.1h-3.5c-.2 0-.4.1-.5.3s0 .4.2.5l3 2.3-1.3 3.6c-.1.3 0 .6.2.8s.6.2.8 0l3.1-2.2 3.1 2.2c.3.2.6.2.8 0s.3-.5.2-.8l-1.3-3.6 3-2.3c.2-.1.2-.3.2-.5z",
      fill: fill
    });
  },
  quickView: function quickView(fill) {
    return _react["default"].createElement("path", {
      d: "M23.41 20.63L30 27.22 27.22 30l-6.59-6.59c-1.928 1.373-4.287 2.181-6.835 2.181-6.514 0-11.796-5.281-11.796-11.796S7.28 1.999 13.795 1.999c6.514 0 11.796 5.281 11.796 11.796 0 2.548-.808 4.906-2.181 6.835zm-7.649-8.8V5.932h-3.932v5.898H5.931v3.932h5.898v5.898h3.932v-5.898h5.898V11.83h-5.898z",
      fill: fill
    });
  },
  quote: function quote(fill) {
    return _react["default"].createElement("path", {
      d: "M17.212 24l-9.524 8v-8.258C4.98 22.952 3 20.436 3 17.454V6.545C3 2.93 5.91 0 9.5 0h12.999C26.088 0 29 2.931 29 6.545v10.909c0 3.616-2.912 6.545-6.501 6.545h-5.287zm-1.586-3.769c1.104 0 2-.892 2-2 0-1.104-.896-2-2-2s-2 .896-2 2c0 1.108.896 1.998 2 2zm.336-16.462c-2.494 0-4.81.954-4.834 4.458h2.526c.026-1.776 1.086-1.888 2.308-1.888 1.442 0 2.276.706 2.276 1.974 0 1.008-.744 1.236-1.464 1.692-1.054.62-2.668 1.354-2.668 3.73-.002.576.02.448.02.496h2.916l-.006-.512c.072-.936.478-1.344 1.632-1.994 1.006-.598 2.204-1.45 2.204-3.416 0-3.018-2.078-4.54-4.91-4.54z",
      fill: fill
    });
  },
  receipt: function receipt(fill) {
    return _react["default"].createElement("path", {
      d: "M10 8h12v4H10V8zM2 27.188L6.812 32 11 28.766 16 32l5-3.234L25.188 32 30 27.188V0H2v27.188zM25 27l-4-3-5 3-5-3-4 3-1-3V4h20v20l-1 3zm-15-9h12v-4H10v4z",
      fill: fill
    });
  },
  redo: function redo(fill) {
    return _react["default"].createElement("path", {
      d: "M18.002 8V3l10 8-10 8v-6c-5.02.632-8.904 3.816-8.904 9C9.098 27.188 20 31.002 20 31.002 12.866 30.358 5 26.298 5 19c0-7.302 5.864-10.358 13.002-11z",
      fill: fill
    });
  },
  refresh: function refresh(fill) {
    return _react["default"].createElement("path", {
      d: "M18 4V0L7.998 6.998 18 14v-4c5.104 0 8.002 2.312 8.002 7 0 5.146-3.856 9.002-9.002 9.002S7.998 21.146 7.998 16H2c0 8.1 6.904 16 15 16 8.1 0 15-6.9 15-15 0-7.648-6.524-12.326-14-13z",
      fill: fill
    });
  },
  reorder: function reorder(fill) {
    return _react["default"].createElement("path", {
      d: "M4 26v-4h24.002v4H4zm0-12h24.002v4H4v-4zm0-8h24.002v4H4V6z",
      fill: fill
    });
  },
  rss: function rss(fill) {
    return _react["default"].createElement("path", {
      d: "M0 12.2v6c7.4 0 13.8 6.4 13.8 13.8h6C19.8 21 11 12.2 0 12.2zm0-12v6c14.2 0 25.8 11.6 25.8 25.8h6C31.8 14.4 17.6.2 0 .2zM7.6 28c0 1.988-1.612 3.6-3.6 3.6S.4 29.988.4 28s1.612-3.6 3.6-3.6 3.6 1.612 3.6 3.6z",
      fill: fill
    });
  },
  save: function save(fill) {
    return _react["default"].createElement("path", {
      d: "M30 0H2C.896 0 0 .896 0 2v24.236c0 .45.152.886.43 1.238l2.97 3.764c.378.482.958.762 1.57.762H8V20h18v12h4c1.104 0 2-.896 2-2V2c0-1.104-.896-2-2-2zM8 4h18v12H8V4zm4 20h10v8H12v-8z",
      fill: fill
    });
  },
  screenshot: function screenshot(fill) {
    return _react["default"].createElement("path", {
      d: "M29.338 2H2.664C1.192 2 0 3.192 0 4.668v20.664c0 1.238.86 2.234 2 2.536V28h28v-.132c1.14-.3 2-1.296 2-2.536V4.668C32 3.192 30.808 2 29.338 2zM10 23.998H4V14h6v9.998zm18 0H14V14h14v9.998zM28 10H4V6h24v4z",
      fill: fill
    });
  },
  screwdriver: function screwdriver(fill) {
    return _react["default"].createElement("path", {
      d: "M22.712 18.712c.162.162.165.412.012.565l-1.311 1.311c-.633.633-1.595.753-2.351.351l-8.944 8.944c-1.176 1.176-3.068 1.167-4.241-.005l-3.754-3.754C.949 24.95.948 23.053 2.118 21.883l8.943-8.943c-.406-.757-.286-1.714.352-2.352l1.311-1.311c.148-.148.406-.148.565.012l3.212 3.211 7.5-7.5c1-1 .947-1.631.947-1.631.029-.204.219-.469.381-.566L29.673.197c.181-.109.459-.066.606.081l1.444 1.444c.154.154.178.444.081.606l-2.606 4.344c-.109.181-.388.363-.602.416 0 0-.731.047-1.595.912-1.864 1.865-7.5 7.5-7.5 7.5l3.212 3.212zM13 15l-8.294 8.294c-.39.39-.394 1.019-.007 1.406l.601.601c.386.386 1.02.379 1.406-.007L15 17l-2-2z",
      fill: fill
    });
  },
  search: function search(fill) {
    return _react["default"].createElement("path", {
      d: "M12 23.998c2.286 0 4.4-.672 6.216-1.782L28 32l4-4-9.784-9.784C23.326 16.4 24 14.286 24 12c0-6.628-5.372-12-12-12S0 5.372 0 12s5.372 11.998 12 11.998zM12 6c3.312 0 6 2.686 6 6 0 3.312-2.688 6-6 6-3.31 0-6.002-2.688-6.002-6 0-3.314 2.692-6 6.002-6z",
      fill: fill
    });
  },
  send: function send(fill) {
    return _react["default"].createElement("path", {
      d: "M16 22L2 12v12c0 1.106.892 1.998 1.998 1.998h24.004C29.108 25.998 30 25.106 30 24V12L16 22zM28 6H4c-1.104 0-2 .896-2 2l14 10L30 8c0-1.104-.894-2-2-2z",
      fill: fill
    });
  },
  share: function share(fill) {
    return _react["default"].createElement("path", {
      d: "M10.524 21.912c.302.086.624-.038.786-.306C12.79 19.176 15.468 16 20 16v6l12-11-12-9v6s-9.772-.086-9.978 13.236c-.004.312.202.59.502.676zM6 26V14c.832-2.522 2.03-4.49 3.448-6H0v24h30V19.988L24 26H6z",
      fill: fill
    });
  },
  shipping: function shipping(fill) {
    return _react["default"].createElement("path", {
      d: "M22 9h4.93c.669 0 1.293.334 1.664.891l3.07 4.606c.219.329.336.715.336 1.109V23c0 1.105-.895 2-2 2h-2c0 2.209-1.791 4-4 4s-4-1.791-4-4h-8c0 2.209-1.791 4-4 4s-4-1.791-4-4H2c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h18c1.105 0 2 .895 2 2v3zm0 8h6v-.789L25.859 13H22v4zM8 27c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm16 0c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z",
      fill: fill
    });
  },
  slack: function slack(fill) {
    return _react["default"].createElement("path", {
      d: "M6.723 20.221c0 1.85-1.511 3.362-3.362 3.362s-3.362-1.511-3.362-3.362c0-1.85 1.511-3.362 3.362-3.362h3.362v3.362zm1.694 0c0-1.85 1.511-3.362 3.362-3.362s3.362 1.511 3.362 3.362v8.417c0 1.85-1.511 3.362-3.362 3.362s-3.362-1.511-3.362-3.362v-8.417zm3.361-13.498c-1.85 0-3.362-1.511-3.362-3.362S9.927-.001 11.778-.001c1.85 0 3.362 1.511 3.362 3.362v3.362h-3.362zm0 1.694c1.85 0 3.362 1.511 3.362 3.362s-1.511 3.362-3.362 3.362H3.361c-1.85 0-3.362-1.511-3.362-3.362S1.51 8.417 3.361 8.417h8.417zm13.499 3.361c0-1.85 1.511-3.362 3.362-3.362s3.362 1.511 3.362 3.362c0 1.85-1.511 3.362-3.362 3.362h-3.362v-3.362zm-1.694 0c0 1.85-1.511 3.362-3.362 3.362s-3.362-1.511-3.362-3.362V3.361c0-1.85 1.511-3.362 3.362-3.362s3.362 1.511 3.362 3.362v8.417zm-3.362 13.499c1.85 0 3.362 1.511 3.362 3.362s-1.511 3.362-3.362 3.362c-1.85 0-3.362-1.511-3.362-3.362v-3.362h3.362zm0-1.694c-1.85 0-3.362-1.511-3.362-3.362s1.511-3.362 3.362-3.362h8.417c1.85 0 3.362 1.511 3.362 3.362s-1.511 3.362-3.362 3.362h-8.417z",
      fill: fill
    });
  },
  slider: function slider(fill) {
    return _react["default"].createElement("path", {
      d: "M0 16l6-6v12l-6-6zm32 0l-6 6V10l6 6zm-20-6v12h8V10h-8zm-2-4h12c1.105 0 2 .895 2 2v16c0 1.105-.895 2-2 2H10c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2z",
      fill: fill
    });
  },
  smile: function smile(fill) {
    return _react["default"].createElement("path", {
      d: "M8 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm16 0c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm2.6 4c-1 0-2 .6-2.4 1.6-1.4 3.2-4.6 5.4-8.2 5.4-3.8 0-6.8-2.2-8.2-5.4-.4-1-1.4-1.6-2.4-1.6-1.8 0-3 1.8-2.4 3.4 2.2 5 7.2 8.6 13 8.6s10.8-3.6 13-8.6c.6-1.6-.6-3.4-2.4-3.4z",
      fill: fill
    });
  },
  smileBig: function smileBig(fill) {
    return _react["default"].createElement("path", {
      d: "M8 10c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm16 0c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm3.8 4H4.2c-1.2 0-2.2 1-2 2.2C3.2 23 9 28 16 28s12.8-5 13.8-11.8c.2-1.2-.8-2.2-2-2.2z",
      fill: fill
    });
  },
  smileWink: function smileWink(fill) {
    return _react["default"].createElement("path", {
      d: "M8 10c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm12-2h6c1.2 0 2-.8 2-2s-.8-2-2-2h-6c-1.2 0-2 .8-2 2s.8 2 2 2zm7.8 6H4.2c-1.2 0-2.2 1-2 2.2C3.2 23 9 28 16 28s12.8-5 13.8-11.8c.2-1.2-.8-2.2-2-2.2z",
      fill: fill
    });
  },
  spacer: function spacer(fill) {
    return _react["default"].createElement("path", {
      d: "M16 2l6 6H10l6-6zm0 28l-6-6h12l-6 6zM4 14v4h24v-4H4zm-4-4h32v12H0V10z",
      fill: fill
    });
  },
  special: function special(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm8.958-19.104c-.108-.302-.376-.496-.702-.496h-5.292L16.69 6.7c-.118-.288-.378-.466-.69-.466s-.572.176-.692.468l-2.274 5.7H7.742c-.324 0-.592.192-.698.496s-.018.626.242.824l4.464 3.532-2.002 5.376c-.162.438-.034.902.336 1.184.37.284.852.296 1.232.034L16 20.562l4.684 3.284c.378.264.864.25 1.232-.034.372-.282.498-.746.336-1.184l-2.002-5.376 4.464-3.532c.26-.196.348-.518.244-.824z",
      fill: fill
    });
  },
  star: function star(fill) {
    return _react["default"].createElement("path", {
      d: "M19.964 11.91h9.676c.994 0 1.406 1.27.604 1.854l-7.83 5.688 2.99 9.202c.308.944-.772 1.73-1.576 1.146L16 24.112 8.172 29.8c-.804.584-1.884-.202-1.576-1.146l2.99-9.202-7.828-5.688c-.804-.584-.392-1.854.602-1.854h9.676l2.99-9.202c.306-.944 1.642-.944 1.948 0l2.99 9.202z",
      fill: fill
    });
  },
  stop: function stop(fill) {
    return _react["default"].createElement("path", {
      d: "M27.314 4.686c-6.248-6.248-16.38-6.248-22.628 0s-6.248 16.38 0 22.628 16.38 6.248 22.628 0 6.248-16.38 0-22.628zm-19.8 19.8C3.41 20.38 2.9 14.04 5.988 9.382l16.63 16.63c-4.658 3.088-11 2.58-15.104-1.526zm18.61-2.038L9.552 5.876c4.644-2.962 10.878-2.416 14.934 1.64 4.054 4.054 4.6 10.29 1.638 14.932z",
      fill: fill
    });
  },
  styles: function styles(fill) {
    return _react["default"].createElement("path", {
      d: "M25.596 30H6.404C3.972 30 2 28.028 2 25.596V6.404C2 3.972 3.972 2 6.404 2h3.079c1.578 0 2.962.83 3.74 2.077 1.352-.912 3.16-1.034 4.668-.164l2.667 1.54c1.379.796 2.165 2.225 2.201 3.709 1.488.033 2.923.819 3.722 2.202l1.54 2.667c.876 1.518.747 3.34-.182 4.695 1.294.767 2.161 2.178 2.161 3.791v3.079C30 28.028 28.028 30 25.596 30zm-11.342-2.936h11.342c.811 0 1.468-.657 1.468-1.468v-3.079c0-.811-.657-1.468-1.468-1.468h-.923l-10.419 6.015zm1.305-4.143l9.382-5.417c.702-.405.943-1.303.537-2.005l-1.54-2.667c-.405-.702-1.303-.943-2.005-.537l-.359.207-6.015 10.419zm-1.672-2.978l5.74-9.942c.405-.702.165-1.6-.537-2.005l-2.667-1.54c-.702-.405-1.6-.165-2.005.537l-.53.919v12.031zM6.404 4.936c-.811 0-1.468.657-1.468 1.468v19.192c0 .811.657 1.468 1.468 1.468h3.079c.811 0 1.468-.657 1.468-1.468V6.404c0-.811-.657-1.468-1.468-1.468H6.404zm2.435 21.09c-.593 0-1.074-.481-1.074-1.074s.481-1.074 1.074-1.074c.593 0 1.074.481 1.074 1.074s-.481 1.074-1.074 1.074z",
      fill: fill
    });
  },
  subscription: function subscription(fill) {
    return _react["default"].createElement("path", {
      d: "M5.753 22.247C7.861 25.697 11.662 28 16 28c5.946 0 10.882-4.325 11.834-10h4.042C30.892 25.893 24.159 32 16 32c-5.44 0-10.246-2.715-13.137-6.863L0 28V18h10l-4.247 4.247zM29.137 6.863L32 4v10H22l4.247-4.247C24.139 6.303 20.338 4 16 4 10.054 4 5.118 8.325 4.166 14H.124C1.108 6.107 7.841 0 16 0c5.44 0 10.246 2.715 13.137 6.863zM16.883 9.767v4.55c.396.11.799.225 1.209.345.588.172 1.162.372 1.721.6s1.059.516 1.497.864c.439.348.791.774 1.057 1.278s.399 1.116.399 1.836c0 .784-.156 1.518-.469 2.202s-.77 1.28-1.372 1.788c-.602.508-1.337.908-2.204 1.2-.56.189-1.173.316-1.838.383v.987c0 .11-.09.2-.2.2h-1.6c-.11 0-.2-.09-.2-.2v-.964c-.352-.027-.7-.07-1.046-.13-.625-.108-1.225-.262-1.798-.462s-1.113-.44-1.616-.72c-.504-.28-.952-.592-1.344-.936l1.106-1.548c.093-.112.215-.206.364-.282s.308-.114.476-.114c.233 0 .485.082.756.246s.592.346.966.546c.373.2.809.382 1.309.546.251.082.527.144.829.185V17.13c-.48-.07-.95-.143-1.223-.218-.578-.16-1.148-.352-1.707-.576s-1.059-.516-1.497-.876c-.439-.36-.791-.81-1.057-1.35s-.399-1.206-.399-1.998c0-.632.147-1.248.441-1.848s.721-1.132 1.281-1.596c.56-.464 1.25-.836 2.071-1.116.57-.194 1.326-.321 2.09-.381V6.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v.963c1.036.061 2.193.21 2.944.449 1.008.32 1.866.768 2.575 1.344l-.938 1.524c-.112.168-.231.29-.357.366s-.282.114-.469.114c-.196 0-.408-.062-.637-.186s-.502-.262-.819-.414c-.317-.152-.688-.29-1.113-.414-.345-.101-.741-.161-1.188-.179zm-2 .07c-.255.023-.471.052-.593.085-.392.108-.721.258-.987.45s-.464.422-.595.69c-.131.268-.196.562-.196.882 0 .408.133.748.399 1.02s.618.504 1.057.696c.182.08.53.156.915.229V9.837zm2 12.312c.59-.099 1.077-.291 1.46-.575.588-.436.882-1.062.882-1.878 0-.456-.133-.828-.399-1.116s-.618-.53-1.057-.726c-.272-.122-.568-.232-.887-.33v4.625z",
      fill: fill
    });
  },
  success: function success(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm6.534-22.562l-8.374 8.31-4.19-4.184-3 3 7.188 7.188L25.532 12.44l-2.998-3.002z",
      fill: fill
    });
  },
  sync: function sync(fill) {
    return _react["default"].createElement("path", {
      d: "M7.4 11.4C9 8 12.2 6 16 6c4.8 0 9 3.6 9.8 8.4l6-1C30.6 5.8 23.8 0 16 0 10.6 0 5.8 2.6 3 7L0 4v10h10l-2.6-2.6zM32 18H22l2.6 2.6C23 23.8 19.6 26 16 26c-4.8 0-9-3.6-9.8-8.4l-6 1C1.4 26.2 8.2 32 16 32c5.2 0 10.2-2.8 13-7l3 3V18z",
      fill: fill
    });
  },
  "switch": function _switch(fill) {
    return _react["default"].createElement("path", {
      d: "M32 16h-5.998L26 10H10v4L0 6.998 10 0v4h22v12zM6 18v4h16v-4l10 7.002L22 32v-4H0V18h6z",
      fill: fill
    });
  },
  table: function table(fill) {
    return _react["default"].createElement("path", {
      d: "M2 18h8v4H2v-4zm0 6h8v4H2v-4zm10-6h8v4h-8v-4zm0 6h8v4h-8v-4zm10-6h8v4h-8v-4zm0 6h8v4h-8v-4zM6 8v4h20V8H6zM4 4h24c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2z",
      fill: fill
    });
  },
  tablet: function tablet(fill) {
    return _react["default"].createElement("path", {
      d: "M26 0H6C3.79 0 2 1.79 2 4v24c0 2.21 1.79 4 4 4h20c2.21 0 4-1.79 4-4V4c0-2.21-1.79-4-4-4zM12.981 30c-.542 0-.981-.464-.981-1 0-.552.43-1 .981-1h6.038c.542 0 .981.464.981 1 0 .552-.43 1-.981 1h-6.038zM6 4h20v22H6V4z",
      fill: fill
    });
  },
  tag: function tag(fill) {
    return _react["default"].createElement("path", {
      d: "M6.313 18.202l8.485 8.485 11.965-11.965.087-8.559-8.582.083L6.312 18.202zm9.72-15.377c.379-.379.891-.595 1.424-.6l11.439-.11c1.113-.011 2.01.882 2.005 1.995l-.117 11.427c-.005.532-.221 1.044-.6 1.423L16.192 30.952c-.792.792-2.068.802-2.849.021L2.029 19.659c-.781-.781-.772-2.057.021-2.849L16.033 2.827zm7.415 9.555c-.792.792-2.068.802-2.849.021s-.772-2.057.021-2.849c.792-.792 2.068-.802 2.849-.021s.772 2.057-.021 2.849z",
      fill: fill
    });
  },
  text: function text(fill) {
    return _react["default"].createElement("path", {
      d: "M4 4v4h24V4H4zm0 22h16v-4H4v4zm0-6h24v-4H4v4zm0-6h24v-4H4v4z",
      fill: fill
    });
  },
  thickArrowDown: function thickArrowDown(fill) {
    return _react["default"].createElement("path", {
      d: "M22 14V2H10v12H4l12 16 12-16h-6z",
      fill: fill
    });
  },
  thickArrowLeft: function thickArrowLeft(fill) {
    return _react["default"].createElement("path", {
      d: "M18 4L2 16l16 12v-6h12V10H18V4z",
      fill: fill
    });
  },
  thickArrowRight: function thickArrowRight(fill) {
    return _react["default"].createElement("path", {
      d: "M14 10H2v12h12v6l16-12L14 4v6z",
      fill: fill
    });
  },
  thickArrowUp: function thickArrowUp(fill) {
    return _react["default"].createElement("path", {
      d: "M28 18L16 2 4 18h6v12h12V18h6z",
      fill: fill
    });
  },
  thinArrowDown: function thinArrowDown(fill) {
    return _react["default"].createElement("path", {
      d: "M23 22l-7 10-7-10zM14 0h4v22h-4V0z",
      fill: fill
    });
  },
  thinArrowLeft: function thinArrowLeft(fill) {
    return _react["default"].createElement("path", {
      d: "M10 24L0 16l10-8zm0-10h22v4H10v-4z",
      fill: fill
    });
  },
  thinArrowRight: function thinArrowRight(fill) {
    return _react["default"].createElement("path", {
      d: "M22 8l10 8-10 8zM0 14h22v4H0v-4z",
      fill: fill
    });
  },
  thinArrowUp: function thinArrowUp(fill) {
    return _react["default"].createElement("path", {
      d: "M9 10l7-10 7 10zm5 0h4v22h-4V10z",
      fill: fill
    });
  },
  tip: function tip(fill) {
    return _react["default"].createElement("path", {
      d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm0-8c1.104 0 2-.892 2-2 0-1.104-.896-2-2-2s-2 .896-2 2c0 1.108.896 1.998 2 2zm.336-16.462c-2.494 0-4.81.954-4.834 4.458h2.526c.026-1.776 1.086-1.888 2.308-1.888 1.442 0 2.276.706 2.276 1.974 0 1.008-.744 1.236-1.464 1.692-1.054.62-2.668 1.354-2.668 3.73-.002.576.02.448.02.496h2.916l-.006-.512c.072-.936.478-1.344 1.632-1.994 1.006-.598 2.204-1.45 2.204-3.416 0-3.018-2.078-4.54-4.91-4.54z",
      fill: fill
    });
  },
  title: function title(fill) {
    return _react["default"].createElement("path", {
      d: "M12.79 6.142h-2.016c-1.203 0-2.087.13-2.653.389S7.08 7.307 6.697 8.08c-.383.773-.616 1.69-.699 2.752H3.999V4h24v6.832H26c-.377-1.841-.908-3.083-1.592-3.726s-1.774-.965-3.272-.965h-2.069v16.956c0 1.097.186 1.861.557 2.292s1.153.646 2.343.646h.619V28H9.339v-1.965h.566c1.203 0 1.984-.221 2.343-.664s.539-1.201.539-2.274V6.141z",
      fill: fill
    });
  },
  tools: function tools(fill) {
    return _react["default"].createElement("path", {
      d: "M5.598 10.085c.239.237.611.3.902.132 1.536-.883 2.828-2.181 3.711-3.717.168-.291.105-.663-.13-.902l-4.443-4.46c-.192-.192-.126-.532.129-.627 2.727-1.006 5.753-.535 7.77 1.482 2.298 2.298 2.555 5.896.941 8.879 0 0 15.639 12.965 15.721 13.025 1.409 1.056 2.176 2.918 1.622 4.901-.404 1.442-1.579 2.617-3.021 3.021-1.983.555-3.845-.213-4.901-1.622-.06-.081-13.025-15.72-13.025-15.72-2.983 1.614-6.58 1.357-8.879-.941C-.023 11.518-.494 8.493.513 5.766c.095-.255.435-.319.627-.129l4.46 4.447zM27 29c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM6.509 17.491L1.53 22.47c-1.945 1.945-1.949 5.111.002 7.062l.936.936c1.952 1.952 5.113 1.952 7.062.002l5.763-5.763c-1.207-1.456-2.475-2.985-3.626-4.374l-6.67 6.67c-.563.563-1.445.55-1.998-.002-.556-.556-.553-1.447-.002-1.998l6.856-6.856c-.323-.39-.622-.751-.89-1.074-.804.232-1.63.373-2.455.419zm15.432-4.506l3.183-3.183c.843-.843 1.556-.889 1.556-.889.209-.052.489-.243.605-.437l2.505-4.175c.113-.188.089-.472-.061-.622l-1.408-1.408c-.143-.143-.428-.177-.622-.061l-4.175 2.505c-.188.113-.374.372-.402.57 0 0 .051.615-.924 1.591l-3.456 3.456c.963.798 2.062 1.71 3.2 2.653z",
      fill: fill
    });
  },
  trash: function trash(fill) {
    return _react["default"].createElement("path", {
      d: "M4 8V6c0-1.108.894-2 2-2h6V2c0-1.104.896-2 2-2h4c1.104 0 2 .896 2 2v2h6.002C27.106 4 28 4.894 28 6.002V8H4zm22 24H6V12h20v20zM14 16h-4v12.002h4V16zm4 0v12.002h4V16h-4z",
      fill: fill
    });
  },
  triangleDown: function triangleDown(fill) {
    return _react["default"].createElement("path", {
      d: "M23.002 10H9l7 12 7.002-12z",
      fill: fill
    });
  },
  triangleLeft: function triangleLeft(fill) {
    return _react["default"].createElement("path", {
      d: "M22 9v14l-12-7 12-7z",
      fill: fill
    });
  },
  triangleRight: function triangleRight(fill) {
    return _react["default"].createElement("path", {
      d: "M10 9v14l12-7-12-7z",
      fill: fill
    });
  },
  triangleUp: function triangleUp(fill) {
    return _react["default"].createElement("path", {
      d: "M23.002 22H9l7-12 7.002 12z",
      fill: fill
    });
  },
  twitter: function twitter(fill) {
    return _react["default"].createElement("path", {
      d: "M32 7zm-9.8-3c-3.6 0-6.6 3-6.6 6.6 0 .6 0 1 .2 1.4-5.4-.2-10.4-2.8-13.6-6.8-.6 1-.8 2-.8 3.2 0 2.2 1.2 4.2 3 5.4-1 0-2-.4-3-.8 0 3.2 2.2 5.8 5.2 6.4-.6.4-1.2.4-1.8.4-.4 0-.8 0-1.2-.2.8 2.6 3.2 4.4 6.2 4.6C7.6 26 4.8 27 1.6 27H0c3 1.8 6.4 3 10 3 12 0 18.6-10 18.6-18.6v-.8c1.2-1 2.4-2 3.2-3.4-1 .4-2.2.8-3.6.8 1.4-.8 2.4-2 2.8-3.6-1.2.8-2.6 1.2-4.2 1.6-1-1.2-2.8-2-4.6-2z",
      fill: fill
    });
  },
  user: function user(fill) {
    return _react["default"].createElement("path", {
      d: "M23.01 22.597c-5.746-.601-2.939-5.732-2.939-5.732 1.035-1.307 1.188-2.146 1.707-3.816.179.065.287-.026.296-.026.752-.604 2.245-3.981.712-4.359C22.314 4.146 19.675.722 16 .72c-3.673.002-6.315 3.425-6.783 7.942-1.533.378-.04 3.756.712 4.359.008 0 .115.091.295.026.519 1.669.673 2.508 1.707 3.816 0 0 2.808 5.13-2.94 5.732-3.566.031-6.74 2.38-6.74 5.817-.001.684.569 2.189 1.179 2.189h25.14c.609 0 1.179-1.505 1.179-2.187 0-3.437-3.173-5.786-6.739-5.817z",
      fill: fill
    });
  },
  undo: function undo(fill) {
    return _react["default"].createElement("path", {
      d: "M14 8V3L4 11l10 8v-6c5.02.632 8.904 3.816 8.904 9 0 5.188-10.902 9.002-10.902 9.002 7.134-.644 15-4.704 15-12.002C27 11.698 21.136 8.642 14 8z",
      fill: fill
    });
  },
  universalNavMyApps: function universalNavMyApps(fill) {
    return _react["default"].createElement("path", {
      d: "M12.906 27.775c0 .672.547 1.225 1.223 1.225h3.744c.674 0 1.222-.551 1.222-1.225v-3.744c0-.674-.547-1.226-1.222-1.226h-3.744c-.674 0-1.223.55-1.223 1.226v3.744zM22.811 27.775c0 .672.546 1.225 1.221 1.225h3.744c.676 0 1.224-.551 1.224-1.225v-3.744c0-.674-.546-1.226-1.224-1.226h-3.744c-.672 0-1.221.55-1.221 1.226v3.744zM27.775 19.093c.676 0 1.224-.546 1.224-1.224v-3.744c0-.672-.546-1.22-1.224-1.22h-3.744c-.672 0-1.221.544-1.221 1.22v3.744c0 .676.546 1.224 1.221 1.224h3.744zM27.775 3h-3.744c-.672 0-1.221.546-1.221 1.222v3.745c0 .674.546 1.223 1.221 1.223h3.744c.676 0 1.224-.548 1.224-1.223V4.222c0-.674-.546-1.222-1.224-1.222zM17.873 9.189c.674 0 1.222-.548 1.222-1.223V4.222c0-.674-.547-1.222-1.222-1.222h-3.744c-.674 0-1.223.546-1.223 1.222v3.745c0 .674.547 1.223 1.223 1.223h3.744zM7.968 9.189c.673 0 1.224-.548 1.224-1.223V4.222C9.192 3.548 8.643 3 7.968 3H4.223C3.55 3 3 3.546 3 4.222v3.745c0 .674.549 1.223 1.223 1.223h3.745zM3 17.869c0 .676.549 1.224 1.223 1.224h3.746c.673 0 1.224-.546 1.224-1.224v-3.744c0-.672-.549-1.22-1.224-1.22H4.223c-.673 0-1.223.544-1.223 1.22v3.744zM12.906 17.869c0 .676.547 1.224 1.223 1.224h3.744c.674 0 1.222-.546 1.222-1.224v-3.744c0-.672-.547-1.22-1.222-1.22h-3.744c-.674 0-1.223.544-1.223 1.22v3.744zM3 27.775C3 28.447 3.549 29 4.223 29h3.746c.673 0 1.224-.551 1.224-1.225v-3.744c0-.674-.549-1.226-1.224-1.226H4.223C3.55 22.806 3 23.355 3 24.031v3.744z",
      fill: fill
    });
  },
  universalNavHome: function universalNavHome(fill) {
    return _react["default"].createElement("g", null, _react["default"].createElement("path", {
      d: "M18.424 29.062h6.969c.71 0 1.285-.575 1.285-1.285v-9.195c0-.054-.008-.09-.021-.117L16.029 9.368c-.013-.009-.028-.015-.042-.015-.013 0-.029.006-.042.015l-10.63 9.097c0 .013-.002.032-.008.058-.006.027-.009.046-.009.06v9.195c0 .71.574 1.285 1.282 1.285h6.97c.036 0 .063-.029.063-.062v-7.275c0-.033.027-.061.061-.061H18.3c.033 0 .061.027.061.061V29c-.001.033.031.062.063.062z",
      fill: fill
    }), _react["default"].createElement("path", {
      d: "M26.678 11.578l-4.751-4.104-5.197-4.437c-.211-.183-.476-.274-.741-.274s-.528.091-.743.275L1.182 15.116c-.212.182-.245.498-.07.719l1.255 1.57c.184.232.524.264.747.073L15.945 6.372c.024-.02.06-.02.084 0l12.79 11.076c.224.192.562.169.756-.056l1.295-1.496c.192-.224.169-.564-.055-.757l-4.137-3.561z",
      fill: fill
    }));
  },
  universalNavInsights: function universalNavInsights(fill) {
    return _react["default"].createElement("path", {
      d: "M26.787 11.38h-3.301c-.663 0-1.201.538-1.201 1.201v14.912c0 .667.546 1.214 1.211 1.214h3.301c.664 0 1.203-.539 1.203-1.202V12.591c0-.667-.547-1.211-1.213-1.211zM17.662 3.293h-3.316c-.665 0-1.206.538-1.206 1.201v23.019c0 .659.537 1.194 1.196 1.194h3.319c.664 0 1.202-.539 1.202-1.202V4.488c0-.66-.537-1.195-1.195-1.195zM8.522 17.155H5.19c-.657 0-1.19.534-1.19 1.191v9.168c0 .659.533 1.192 1.19 1.192h3.322c.663 0 1.202-.539 1.202-1.202v-9.158c0-.657-.535-1.191-1.192-1.191z",
      fill: fill
    });
  },
  universalNavMarketplace: function universalNavMarketplace(fill) {
    return _react["default"].createElement("path", {
      d: "M28.455 15v11.75c0 .69-.581 1.25-1.297 1.25h-7.006v-5.9c0-.055-.046-.1-.104-.1h-8.096c-.057 0-.104.045-.104.1V28H4.842c-.717 0-1.297-.56-1.297-1.25V15h3.892c.906 0 1.729-.344 2.335-.905.606.56 1.429.905 2.335.905h1.557c.906 0 1.729-.344 2.335-.905.606.56 1.429.905 2.335.905h1.557c.906 0 1.729-.344 2.335-.905.606.56 1.429.905 2.335.905h3.892zM17.142 3h3.944c.057 0 .104.045.104.1v8.65c0 .69-.581 1.25-1.297 1.25h-1.557c-.717 0-1.297-.56-1.297-1.25V3.1c0-.055.046-.1.104-.1zm-6.228 0h3.944c.057 0 .104.045.104.1v8.65c0 .69-.581 1.25-1.297 1.25h-1.557c-.717 0-1.297-.56-1.297-1.25V3.1c0-.055.046-.1.104-.1zM6.022 3H8.63c.057 0 .104.045.104.1v8.65c0 .69-.581 1.25-1.297 1.25H3.298c-.717 0-1.297-.56-1.297-1.25 0-.141.025-.28.073-.413l2.725-7.5C4.981 3.336 5.472 3 6.024 3zm17.347 0h2.609c.551 0 1.042.336 1.225.837l2.725 7.5c.237.652-.12 1.365-.796 1.593-.138.046-.283.07-.429.07h-4.139c-.717 0-1.297-.56-1.297-1.25V3.1c0-.055.046-.1.104-.1z",
      fill: fill
    });
  },
  universalNavMessenger: function universalNavMessenger(fill) {
    return _react["default"].createElement("g", null, _react["default"].createElement("path", {
      d: "M26.042 22.121c-5.016-.516-2.568-4.924-2.568-4.924.905-1.127 1.039-1.848 1.494-3.28.152.053.247-.025.255-.025.658-.52 1.963-3.42.624-3.746-.409-3.881-2.716-6.824-5.921-6.827-.881.002-1.687.228-2.408.628 1.233 1.329 2.121 3.147 2.501 5.312.312.349.522.777.637 1.257.383 1.702-.715 4.05-1.713 4.991-.302.975-.614 1.855-1.446 2.938-.248.533-.367 1.211-.244 1.43.052.104.372.316 1.19.414 4.359.086 7.766 3.139 7.766 6.971 0 .432-.126 1.088-.4 1.74H30.9c.528 0 1.025-1.295 1.025-1.881-.001-2.953-2.769-4.973-5.883-4.998z",
      fill: fill
    }), _react["default"].createElement("path", {
      d: "M18.038 22.096c-4.995-.516-2.555-4.904-2.555-4.904.898-1.119 1.031-1.834 1.482-3.265.157.052.252-.022.26-.022.654-.518 1.949-3.409.615-3.73-.404-3.864-2.703-6.793-5.893-6.794S6.461 6.31 6.052 10.174c-1.33.323-.035 3.212.62 3.73.007 0 .101.074.255.022.452 1.429.585 2.146 1.483 3.265 0 0 2.438 4.389-2.555 4.904C2.757 22.121 0 24.131 0 27.068c0 .588.494 1.873 1.023 1.873h21.848c.528 0 1.024-1.287 1.024-1.873.001-2.937-2.758-4.947-5.857-4.972z",
      fill: fill
    }));
  },
  unlink: function unlink(fill) {
    return _react["default"].createElement("path", {
      d: "M16.492 29.17zM2.77 29.166c-3.79-3.778-3.79-9.902 0-13.68l4.118 4.102c-.734.732-1.138 1.708-1.138 2.738s.404 2.004 1.138 2.734c.734.732 1.708 1.134 2.744 1.134s2.01-.402 2.744-1.134l4.116 4.106C14.6 31.054 12.116 32 9.632 32s-4.968-.946-6.862-2.834zm0-13.682v.002l-.004-.002h.004zm26.406 1.03l.004.006-4.122-4.108c.734-.732 1.138-1.708 1.138-2.738 0-1.034-.404-2.004-1.142-2.738-.726-.73-1.704-1.132-2.74-1.132s-2.01.402-2.744 1.136l-4.116-4.108C17.346.946 19.83 0 22.314 0s4.968.946 6.862 2.83c3.79 3.782 3.79 9.91 0 13.684zm-3.36 9.292c-1.038 1.036-2.686 1.116-3.82.192l-16.056-16c-.766-1.144-.616-2.664.36-3.636.976-.974 2.502-1.124 3.65-.362l16.056 15.998c.928 1.132.846 2.78-.19 3.808z",
      fill: fill
    });
  },
  unlock: function unlock(fill) {
    return _react["default"].createElement("path", {
      d: "M26 16H12V8c0-2.21 1.79-4 4-4s4 1.79 4 4v3c0 .552.448 1 1 1h2c.552 0 1-.448 1-1V8c0-4.418-3.582-8-8-8S8 3.582 8 8v8H6c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2V18c0-1.104-.896-2-2-2zm-8 9c0 .552-.448 1-1 1h-2c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h2c.552 0 1 .448 1 1v2z",
      fill: fill
    });
  },
  upload: function upload(fill) {
    return _react["default"].createElement("path", {
      d: "M0 32V16h6v10h18V16h6v16H0zM14.998 2L8 12h4v10h6V12h4L14.998 2z",
      fill: fill
    });
  },
  users: function users(fill) {
    return _react["default"].createElement("g", null, _react["default"].createElement("path", {
      d: "M26.098 21.649c-5.029-.489-2.575-4.668-2.575-4.668.907-1.066 1.04-1.749 1.495-3.108.156.052.25-.021.259-.021.657-.492 1.966-3.243.622-3.552-.408-3.678-2.72-6.466-5.934-6.468-.881.001-1.689.216-2.413.595 1.235 1.259 2.128 2.983 2.507 5.034.312.33.526.735.637 1.19.385 1.613-.713 3.838-1.715 4.729-.304.925-.617 1.759-1.449 2.786-.25.505-.37 1.146-.248 1.356.055.097.375.299 1.195.39 4.369.082 7.784 2.976 7.784 6.606 0 .408-.126 1.032-.399 1.649h5.101c.53 0 1.029-1.226 1.029-1.782-.001-2.799-2.776-4.709-5.896-4.736z",
      fill: fill
    }), _react["default"].createElement("path", {
      d: "M18.074 21.624c-5.006-.488-2.56-4.647-2.56-4.647.899-1.061 1.034-1.74 1.486-3.095.156.052.249-.021.257-.021.657-.49 1.956-3.229.619-3.534-.405-3.662-2.708-6.438-5.907-6.439-3.199.001-5.5 2.777-5.909 6.439-1.335.306-.035 3.044.621 3.534.007 0 .101.073.256.021.452 1.354.587 2.034 1.486 3.095 0 0 2.445 4.159-2.56 4.647-3.107.025-5.871 1.928-5.871 4.714 0 .555.496 1.775 1.027 1.775h21.899c.529 0 1.026-1.221 1.026-1.775.001-2.786-2.765-4.689-5.87-4.714z",
      fill: fill
    }));
  },
  video: function video(fill) {
    return _react["default"].createElement("path", {
      d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm0 28.008C9.368 28.008 3.992 22.632 3.992 16S9.368 3.992 16 3.992 28.008 9.368 28.008 16 22.632 28.008 16 28.008zM13.812 9.84c-.37-.23-.8-.242-1.18-.032-.38.212-.6.582-.6 1.018v10.346c0 .436.218.806.6 1.018.38.212.812.2 1.18-.032l8.278-5.174c.35-.216.546-.57.546-.984s-.196-.768-.546-.986L13.812 9.84z",
      fill: fill
    });
  },
  wink: function wink(fill) {
    return _react["default"].createElement("path", {
      d: "M8 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm12-2h6c1.2 0 2-.8 2-2s-.8-2-2-2h-6c-1.2 0-2 .8-2 2s.8 2 2 2zm6.6 6c-1 0-2 .6-2.4 1.6-1.4 3.2-4.6 5.4-8.2 5.4-3.8 0-6.8-2.2-8.2-5.4-.4-1-1.4-1.6-2.4-1.6-1.8 0-3 1.8-2.4 3.4 2.2 5 7.2 8.6 13 8.6s10.8-3.6 13-8.6c.6-1.6-.6-3.4-2.4-3.4z",
      fill: fill
    });
  },
  youtube: function youtube(fill) {
    return _react["default"].createElement("path", {
      d: "M31.331 8.592C32 11.154 32 16.5 32 16.5s0 5.346-.669 7.909c-.368 1.414-1.452 2.527-2.829 2.905C26.007 28 16 28 16 28s-10.007 0-12.502-.686c-1.377-.378-2.461-1.491-2.829-2.905C0 21.846 0 16.5 0 16.5s0-5.346.669-7.908c.368-1.414 1.452-2.527 2.829-2.905C5.993 5 16 5 16 5s10.007 0 12.502.687c1.377.378 2.461 1.491 2.829 2.905zM12.727 21.354l8.364-4.854-8.364-4.854v9.708z",
      fill: fill
    });
  }
};
var _default = content;
exports["default"] = _default;